import React from "react";
import {
  Page,
  Card,
  Button,
  Table,
  TableToolbar,
  Search,
  Box,
  Tooltip,
  TextButton,
  Badge,
  Text,
  NumberInput,
  Modal,
  Loader,
  Heading,
  Divider,
  Radio,
  SidePanel,
  CustomModalLayout,
  FormField,
  Input,
  Cell,
  Layout,
  TableListHeader,
  Checkbox,
  Popover,
  PopoverMenu,
  RadioGroup,
  Tabs,
  Image,
  TagList,
  Accordion,
  DatePicker,
  Slider,
  Pagination
} from '@wix/design-system';

import { ContentFilterSmall, StatusWarningFilled, ShippingSmall, RedoSmall, PrintSmall, ChevronDownLargeSmall, DocumentSmall, MapSmall, ChevronDownSmall, DownloadImportSmall, DeleteSmall} from '@wix/wix-ui-icons-common';

import dpd from "../../../assets/images/dpd.png";
import austria from "../../../assets/images/austria.png";
import italy from "../../../assets/images/italy.png";
import germany from "../../../assets/images/germany.png";
import luxembourg from "../../../assets/images/luxembourg.png";
import LogoColissimo from "../../../assets/images/Colissimo_Logo_H.png";

import { passCsrfToken } from '../../util/helpers'
import axios from 'axios'
import { openPrintWindow, PRINT_WINDOW_CLOSED } from '../utils/printWindow'
import { formatPrice, VAT_RATE } from '../utils/formatPrice'

class OrderIndex extends React.Component {

  componentDidMount = () => {
    passCsrfToken(document, axios);
    this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
  }

  state = {
    orders: this.props.orders,
    page: this.props.page,
    page_limit: this.props.page_limit,
    count_orders: this.props.count_orders,
    total_page: this.props.total_page,
    global_lines_weight: 0,
    weight: null,
    sheetActive: false,
    selectedOrder: false,
    selectedLabels: false,
    selectedChange: false,
    selectedChangeOffer: false,
    loading: true,
    map_modal: false,
    countries: [],
    services: [],
    queryValue: null,
    date: [],
    date_to: null,
    date_from: null,
    paymentStatus: [],
    labelStatus: [],
    closedStatus: null,
    errorStatus: [],
    printedStatus: [],
    fulfillmentStatus: [],
    sortValue: 'DESC',
    isFirstPage: false,
    isLastPage: true,
    modalChangeAddress: false,
    modalChangeAddressPickup: false,
    modalRegenerate: false,
    modalRegenerateReturn: false,
    modalBulkGenerate: false,
    orderShippingPickup: false,
    orderShipping: false,
    selectedItems: [],
    selectedTabConfig: 0,
    filterSide: false,
    modalImport: false,
    import_orders: null,
    remaining_days: this.props.remaining_days,
    modalOpenOrderlistBuklDelete: false,
    /* Tarifs Colissimo du volet « Changer le mode de livraison », indexés par
       valeur de bouton radio : { DOM: { amount_total_ht }, PICKUP: {...} }.
       `false` tant qu'aucune cotation n'a été demandée pour la commande
       ouverte, ce qui permet de distinguer « pas encore chargé » de « aucun
       tarif disponible » (objet vide). */
    cotationPrices: false,
    cotationLoading: false,
  }

  handleOpenSheet = (order_id, action_type = "order") => {
    if (action_type == "order") {
      this.getOrderRequest(order_id);
    } else if (action_type == "change") {
      this.getChangeOrderRequest(order_id);
    } else if (action_type == "change_offer") {
      this.getChangeOfferOrderRequest(order_id);
    } else {
      this.getLabelsRequest(order_id);
    }
  };

  handleCloseSheet = () => {
    /* Les tarifs sont propres à une commande : les garder ferait apparaître
       ceux de la précédente le temps que la nouvelle cotation revienne. */
    this.setState({cotationPrices: false});
    this.setState({cotationLoading: false});
    this.setState({colissimo_service: false});
    this.setState({colissimo_international_offer: false});
    this.setState({sheetActive: false});
    this.setState({global_lines_weight: 0});
    this.setState({selectedChange: false});
    this.setState({selectedChangeOffer: false});
    this.setState({selectedOrder: false});
    this.setState({selectedLabels: false});
    this.setState({filterSide: false});
  };

  handleToggleSheet = (order_id, action_type = "order") => {
    this.state.sheetActive ? this.handleCloseSheet() : this.handleOpenSheet(order_id, action_type);
  }

  toggleActive = (field) => {
    this.setState({ [field]: !this.state[field] });
  }

  toggleTag = (type, value) => {
    if (type === 'labelStatus' || type === 'date' || type === 'printedStatus') {
      if (value != 'custom') {
        this.setState({ [type]: [value] }, () =>
          this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit)
        );
      } else {
        this.setState({ date_to: null });
        this.setState({ date_from: null });
        this.setState({ [type]: [value] });
      }
    } else if (type === 'weight') {
      this.setState({ [type]: value }, () =>
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit)
      );
    } else {
      if (this.state[type].some((tag) => tag === value)) {
        this.setState({
          [type]: this.state[type].filter(item => item !== value)
        }, () =>
          this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit)
        );
      } else {
        this.setState({
          [type]: [...this.state[type], value]
        }, () =>
          this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit)
        );
      }
    }
  };

  handleChangeWithValue = (field, value) => {
    if (field.indexOf('ftd') !== -1) {
      this.setState({ [field]: value });
      this.toggleActive(field.replace('ftd', 'activeddp'));
    } else {
      this.setState({ [field]: value });
    }
  }

  handleChangeAddress = (e) => {
    this.setState({
      orderShipping: { ...this.state.orderShipping, [e.target.name]: e.target.value },
    });
  }

  handleChangeImportOrders = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  /* Délai avant de lancer la recherche, en ms. La frappe reste affichée
     immédiatement ; seule la requête est différée. */
  SEARCH_DEBOUNCE_MS = 400;

  handleChangeQueryValue = (e) => {
    const name = e.target.name || 'queryValue';
    const value = e.target.value;

    // Le champ est contrôlé : on met le state à jour à CHAQUE caractère pour
    // que la saisie s'affiche sans latence. Auparavant le debounce était
    // délégué au composant Search (debounceMs), si bien que `value` ne
    // changeait qu'après le délai : à chaque rechargement du tableau, Search
    // réappliquait cette valeur périmée et écrasait les caractères tapés
    // entre-temps — d'où l'impossibilité d'enchaîner la frappe.
    this.setState({ [name]: value });

    // Seul l'appel réseau est différé, et relancé à chaque frappe.
    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => {
      this.callRequest('/orders-filters?page=1&limit='+this.state.page_limit, false, true);
    }, this.SEARCH_DEBOUNCE_MS);
  }

  /* Croix de la barre de recherche. Sans ce handler, Search en mode contrôlé
     ne vide ni son affichage ni le state : le champ restait rempli et la
     liste filtrée. */
  handleClearQueryValue = () => {
    clearTimeout(this._searchTimer);
    this.setState({ queryValue: '' }, () => {
      this.callRequest('/orders-filters?page=1&limit='+this.state.page_limit, false, true);
    });
  }

  componentWillUnmount = () => {
    clearTimeout(this._searchTimer);
  }

  handleChangeDpd = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  handleChangeAddressPickup = (e) => {
    this.setState({
      orderShippingPickup: { ...this.state.orderShippingPickup, [e.target.name]: e.target.value },
    });
  }

  handleChange = (field) => {

    const includeFilters = [
      'queryValue',
      'weight',
      'date',
      'date_from',
      'date_to',
      'countries',
      'services',
    ];

    return (value) => {
      console.log(value);
      if (field != 'map_modal') {
        this.setState({ page: 1 });
      }

      if (field === 'map_modal') {
        this.setState({ map_modal: false });
        try { jQuery('#colissimo-widget-container').frameColissimoClose(); } catch(e) {}
        if (window.ColissimoPickupMap) { ColissimoPickupMap.close(); }
        return true;
      }

      this.setState({ [field]: value }, () => {
        if (includeFilters.indexOf(field) !== -1) {
          if (Array.isArray(value)) {
            if (value[0] == "custom") {
              return true;
            }
          }
          this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
        };
      });
    };
  };

  changeAddress = (shipping) => {
    this.setState({selectedChange: false});
    this.setState({selectedChangeOffer: false});
    this.setState({selectedOrder: false});
    this.setState({selectedLabels: false});
    this.setState({modalChangeAddress: true});
    this.setState({orderShipping: shipping});
    this.setState({modalOpenOrderlistBuklDelete: false});
  }

  changeAddressPickup = (shipping) => {
    this.setState({selectedChange: false});
    this.setState({selectedChangeOffer: false});
    this.setState({selectedOrder: false});
    this.setState({selectedLabels: false});
    this.setState({modalChangeAddressPickup: true});
    this.setState({orderShippingPickup: shipping});
    this.setState({modalOpenOrderlistBuklDelete: false});
  }

  dialogConfirmDelete = () => {
    this.setState({modalOpenOrderlistBuklDelete: true});
  }

  handleSelectionChange = (selectedItems) => {
    this.setState({selectedItems});
  };

  changeService = (order_id, shipping, product_code) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    if (!this.state.colissimo_service) {
      product_code = product_code
    } else {
      product_code = this.state.colissimo_service;
    }

    if (product_code == 'PICKUP') {
      this.loadMap(order_id, shipping);
    } else {
      /* We save new service */
      this.setState({map_modal: false});
      this.setState({loading: true});
      axios({
        method: 'post',
        url: '/save-backend-service',
        data: {
          orderId: order_id,
          productCode: product_code,
          instance_id: this.props.shop.instance_id
        }
      }).then(result => {
        this.setState({loading: false});
        if (result.data.success == true) {
          this.props.toggleToast(I18n.t('order_list.success_update_change_service'), false);
        } else {
          this.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
        }

        this.setState({selectedChange: false});
        this.setState({selectedChangeOffer: false});
        this.setState({colissimo_service: false});
        this.setState({colissimo_international_offer: false})
        this.setState({order_id_update_service: false});
        this.setState({map_modal: false});
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      }).catch(error => {
        console.log(error);
        this.setState({loading: false});
        this.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
        this.setState({selectedChange: false});
        this.setState({selectedChangeOffer: false});
        this.setState({colissimo_service: false});
        this.setState({colissimo_international_offer: false})
        this.setState({order_id_update_service: false});
        this.setState({map_modal: false});
      });
    }
  }

  changeOffer = (order_id, colissimo_international_offer) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    if (!this.state.colissimo_international_offer) {
      colissimo_international_offer = colissimo_international_offer
    } else {
      colissimo_international_offer = this.state.colissimo_international_offer;
    }

    axios({
      method: 'post',
      url: '/save-backend-offer',
      data: {
        orderId: order_id,
        colissimoInternationalOffer: colissimo_international_offer,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast(I18n.t('order_list.success_update_change_service'), false);
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      } else {
        this.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
      }
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({colissimo_service: false});
      this.setState({colissimo_international_offer: false})
      this.setState({order_id_update_service: false});
      this.setState({map_modal: false});
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({colissimo_service: false});
      this.setState({colissimo_international_offer: false})
      this.setState({order_id_update_service: false});
      this.setState({map_modal: false});
    });
  }


  loadMap = (order_id, shipping) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }

    this.setState({selectedChange: false});
    this.setState({selectedChangeOffer: false});
    this.setState({selectedOrder: false});
    this.setState({selectedLabels: false});
    this.setState({colissimo_service: false});
    this.setState({colissimo_international_offer: false});
    this.setState({order_id_update_service: order_id});

    // Load Leaflet pickup widget script if not already loaded
    if (!document.getElementById('pickup-leaflet-script-bo')) {
      var s = document.createElement('script');
      s.id = 'pickup-leaflet-script-bo';
      s.src = '/pickup-leaflet.js';
      document.head.appendChild(s);
    }

    var self = this;
    var countryCode = shipping.country_code === 'MC' ? 'FR' : (shipping.country_code || 'FR');
    var buttonColor = this.props.config ? this.props.config.button_color : '#5a7d8f';

    var tryOpen = function() {
      if (window.ColissimoPickupMap) {
        ColissimoPickupMap.open({
          backendUrl: window.location.origin,
          shopId: self.props.shop.id,
          address: shipping.address1 || '',
          postcode: shipping.zip || '',
          city: shipping.city || '',
          countryCode: countryCode,
          primaryColor: buttonColor || '#5a7d8f',
          onSelect: function(point) {
            var infoPoint = {
              colissimo_id: point.point_id,
              company_name: point.name,
              address1: point.address1,
              address2: point.address2 || '',
              address3: point.address3 || '',
              city: point.city,
              zipcode: point.zipcode,
              country: point.country,
              iso_country: point.country_code,
              product_code: point.type || '',
              network: point.network || ''
            };
            // Save directly via API (bypass hidden field which requires modal to be open)
            axios({
              method: 'post',
              url: '/save-backend-pickup-point',
              data: {
                orderId: self.state.order_id_update_service,
                infoPoint: infoPoint,
                instance_id: self.props.shop.instance_id
              }
            }).then(function(result) {
              if (result.data.success === true) {
                self.props.toggleToast(I18n.t('order_list.success_update_change_service'), false);
              } else {
                self.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
              }
              self.setState({order_id_update_service: false});
              self.callRequest('/orders-filters?page='+self.state.page+'&limit='+self.state.page_limit);
            }).catch(function(error) {
              console.log(error);
              self.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
            });
          }
        });
      } else {
        setTimeout(tryOpen, 200);
      }
    };
    tryOpen();

    console.log('Colissimo APP : Leaflet Map loaded');
  }

  handleValidPickup = () => {
    this.setState({ map_modal: false });
    try { jQuery('#colissimo-widget-container').frameColissimoClose(); } catch(e) {}
    this.savePickupPoint();
  }

  savePickupPoint = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    var infoPointValue = JSON.parse(this.orderUpdateWebservice.value);
    axios({
      method: 'post',
      url: '/save-backend-pickup-point',
      data: {
        orderId: this.state.order_id_update_service,
        infoPoint: infoPointValue.infoPoint,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast(I18n.t('order_list.success_update_change_service'), false);
      } else {
        this.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
      }
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({colissimo_service: false});
      this.setState({colissimo_international_offer: false})
      this.setState({order_id_update_service: false});
      this.setState({map_modal: false});
      this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.error_update_change_service'), true);
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({colissimo_service: false});
      this.setState({colissimo_international_offer: false})
      this.setState({order_id_update_service: false});
      this.setState({map_modal: false});
    });
  }

  handleSubmit = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});

    axios({
      method: 'post',
      url: '/modify-address',
      data: {
        shipping: this.state.orderShipping,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.setState({modalChangeAddress: false});
        this.props.toggleToast(I18n.t('order_list.success_update_modify_address'), false);
        this.handleToggleSheet(this.state.orderShipping.order_id, 'change');
      } else {
        this.props.toggleToast(I18n.t('order_list.error_update_modify_address'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.error_update_modify_address'), true);
    });

  }

  handleSubmitPickup = (event) => {
    event.preventDefault();
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});

    axios({
      method: 'post',
      url: '/modify-address-pickup',
      data: {
        shipping: this.state.orderShippingPickup,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.setState({modalChangeAddressPickup: false});
        this.props.toggleToast(I18n.t('order_list.success_update_modify_address'), false);
        this.handleToggleSheet(this.state.orderShippingPickup.order_id, 'change');
      } else {
        this.props.toggleToast(I18n.t('order_list.error_update_modify_address'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.error_update_modify_address'), true);
    });
  }

  handleChangeDdp = (order_id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }

    this.setState({loading: true});
    if (typeof $ === 'undefined') {
        $ = jQuery;
    }

    /* We verify if weight is set */
    axios({
      method: 'post',
      url: '/update-ddp-value',
      data: {
        order_id: order_id,
        height: $("#height"+order_id).val(),
        width: $("#width"+order_id).val(),
        length: $("#length"+order_id).val(),
        description: $("#description"+order_id).val(),
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast(I18n.t('order_list.update_ddp_success'), false);
        this.toggleActive(`activeddp${order_id}`);
      } else {
        this.props.toggleToast(I18n.t('order_list.update_ddp_error'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.update_ddp_error'), true);
    });
  };

  defaultInsuranceTier = (amount, restricted) => {
    const value = Number(amount) || 0;
    const max = restricted ? 1000 : 5000;
    const tiers = restricted ? [150, 300, 500, 1000] : [150, 300, 500, 1000, 2000, 5000];
    if (value <= 150) return 150;
    for (let i = 0; i < tiers.length; i++) {
      if (value <= tiers[i]) return tiers[i];
    }
    return max;
  };

  closeInsurancePopover = (order_id) => {
    this.setState({
      ["insurance_amount"+order_id]: undefined,
      ["activeinsurance"+order_id]: false,
    });
  };

  closeInsuranceReturnPopover = (order_id) => {
    this.setState({
      ["insurance_return_amount"+order_id]: undefined,
      ["activeinsurancereturn"+order_id]: false,
    });
  };

  handleChangeInsurance = (order_id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }

    const valueToSave = this.state["insurance_amount"+order_id];

    this.setState({loading: true});

    axios({
      method: 'post',
      url: '/update-insurance-value',
      data: {
        order_id: order_id,
        insurance_value: valueToSave,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast(I18n.t('order_list.update_insurance_success'), false);
        this.setState({
          ["saved_insurance"+order_id]: valueToSave,
          ["insurance_amount"+order_id]: undefined,
          ["activeinsurance"+order_id]: false,
        });
      } else {
        this.props.toggleToast(I18n.t('order_list.update_insurance_error'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.update_insurance_error'), true);
    });
  };

  handleChangeInsuranceReturn = (order_id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }

    const valueToSave = this.state["insurance_return_amount"+order_id] !== undefined ? this.state["insurance_return_amount"+order_id] : 0;

    this.setState({loading: true});

    axios({
      method: 'post',
      url: '/update-insurance-return-value',
      data: {
        order_id: order_id,
        insurance_value: valueToSave,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast(I18n.t('order_list.update_insurance_success'), false);
        this.setState({
          ["saved_insurance_return"+order_id]: valueToSave,
          ["insurance_return_amount"+order_id]: undefined,
          ["activeinsurancereturn"+order_id]: false,
        });
      } else {
        this.props.toggleToast(I18n.t('order_list.update_insurance_error'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.update_insurance_error'), true);
    });
  };

  /* Compose le message de retour de l'import à partir du bilan renvoyé par le back */
  getImportOrdersResult = (data) => {
    const imported = (data.imported || []).length;
    const restored = (data.restored || []).length;
    const already = (data.already_present || []).length;
    const notFound = (data.not_found || []).length;
    const failed = (data.failed || []).length;
    const parts = [];

    if (imported > 0) {
      parts.push(I18n.t('order_list.modal.import_result_imported', {number: imported}));
    }
    if (restored > 0) {
      parts.push(I18n.t('order_list.modal.import_result_restored', {number: restored}));
    }
    if (already > 0) {
      parts.push(I18n.t('order_list.modal.import_result_already', {number: already}));
    }
    if (notFound > 0) {
      parts.push(I18n.t('order_list.modal.import_result_not_found', {number: notFound}));
    }
    if (failed > 0) {
      parts.push(I18n.t('order_list.modal.import_result_failed', {number: failed}));
    }

    /* Aucun détail renvoyé : on conserve le message générique */
    if (parts.length === 0) {
      return {message: I18n.t('order_list.modal.success_import_orders'), error: false};
    }

    /* Aucune commande ajoutée ni restaurée : on alerte le marchand */
    return {message: parts.join(', ') + '.', error: (imported === 0 && restored === 0)};
  }

  handleImportOrders = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});

    axios({
      method: 'post',
      url: '/import-orders',
      data: {
        orders: this.state.import_orders,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      this.setState({modalImport: false});
      if (result.data.success == true) {
        const importResult = this.getImportOrdersResult(result.data);
        this.setState({import_orders: null});
        this.props.toggleToast(importResult.message, importResult.error);
        this.callRequest('/orders-filters');
      } else {
        this.props.toggleToast(I18n.t('order_list.modal.error_import_orders'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({modalImport: false});
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.modal.error_import_orders'), true);
    });
  }

  getChangeOrderRequest = (order_id) => {

    this.setState({loading: true});
    axios({
      method: 'post',
      url: '/get-order',
      data: {
        order_id: order_id,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({selectedLabels: false});
      this.setState({selectedChange: result.data});
      this.setState({selectedChangeOffer: false});
      this.setState({selectedOrder: false});
      this.setState({loading: false});
      this.setState({sheetActive: true});

      /* Cotation des modes de livraison proposés, une fois la commande
         connue : c'est elle qui donne le pays destinataire et le poids. */
      const shipping = result.data && result.data.order_shipping;
      if (shipping) {
        const services = this.buildDeliveryOptions(shipping.country_code).map(o => o.value);
        this.setState({cotationPrices: false});
        this.getCotationPreview(order_id, services, this.cotationWeightFor(result.data.order));
      }
    }).catch(error => {
      console.log(error);
      this.setState({selectedLabels: false});
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({selectedOrder: false});
      this.setState({loading: false});
    });
  }

  getChangeOfferOrderRequest = (order_id) => {

    this.setState({loading: true});
    axios({
      method: 'post',
      url: '/get-order',
      data: {
        order_id: order_id,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({selectedLabels: false});
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: result.data});
      this.setState({selectedOrder: false});
      this.setState({loading: false});
      this.setState({sheetActive: true});
    }).catch(error => {
      console.log(error);
      this.setState({selectedLabels: false});
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({selectedOrder: false});
      this.setState({loading: false});
    });
  }

  /* Get order detail */
  getOrderRequest = (order_id) => {
    this.setState({loading: true});
    axios({
      method: 'post',
      url: '/get-order',
      data: {
        order_id: order_id,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({selectedLabels: false});
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({selectedOrder: result.data});
      this.setState({loading: false});
      this.setState({sheetActive: true});
    }).catch(error => {
      console.log(error);
      this.setState({selectedLabels: false});
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({selectedOrder: false});
      this.setState({loading: false});
    });
  }

  /* Get order detail */
  getLabelsRequest = (order_id) => {
    this.setState({loading: true});
    axios({
      method: 'post',
      url: '/get-labels',
      data: {
        order_id: order_id,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({selectedOrder: false});
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({selectedLabels: result.data});
      this.setState({loading: false});
      this.setState({sheetActive: true});
    }).catch(error => {
      console.log(error);
      this.setState({selectedOrder: false});
      this.setState({selectedLabels: false});
      this.setState({selectedChange: false});
      this.setState({selectedChangeOffer: false});
      this.setState({loading: false});
    });
  }

  /* generate Label */
  generateLabel = (order_id, partial = false, label_id = false, regenerate = false) => {
    this.reinitVars();
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});
    if (typeof $ === 'undefined') {
      $ = jQuery;
    }

    /* We verify if weight is set */
    if (
        (parseInt($("#weight"+order_id).val(), 10) <= 0 || isNaN(parseInt($("#weight"+order_id).val(), 10)))
    ) {
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.error_weight'), true);
    } else {
      var weight = parseInt($("#weight"+order_id).val(), 10);
      if (regenerate === true) {
        var returnValue = false;
      } else {
        var returnValue = $("#return"+order_id).is(":checked");
      }

      /* Impression automatique après génération : la fenêtre doit être ouverte
         maintenant, pendant le clic. Elle patiente le temps de la génération. */
      const printSession = (this.props.config.use_thermal_printer == true && this.props.config.generate_and_print == true)
        ? this.openPrintSession()
        : null;

      axios({
        method: 'post',
        url: '/generate-label',
        data: {
          order_id: order_id,
          weight: weight,
          insurance: $("#insurance"+order_id).is(":checked"),
          is_return: returnValue,
          non_machinable: $("#machinable"+order_id).is(":checked"),
          ftd: $("#ftd"+order_id).is(":checked"),
          partial: partial,
          label_id: label_id,
          instance_id: this.props.shop.instance_id
        }
      }).then(result => {
        this.setState({loading: false});
        if (result.data.success == true) {
          this.props.toggleToast(result.data.response_ws.message, false);
          if (printSession) {
            printSession.send({
              protocole: this.props.config.usb_protocole,
              requests: ['/colissimo-label-by-order/'+order_id+'/'+this.props.shop.instance_id]
            });
          }
        } else {
          if (printSession) printSession.cancel(result.data.response_ws.message);
          this.props.toggleToast(result.data.response_ws.message, true);
        }
        if (!regenerate) {
          this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
        } else {
          this.getLabelsRequest(order_id);
        }
      }).catch(error => {
        console.log(error);
        if (printSession) printSession.cancel(I18n.t('order_list.error_generate_label'));
        this.setState({loading: false});
        this.props.toggleToast(I18n.t('order_list.error_generate_label'), true);
      });
    }
  };

  generate_partial = (order_id) => {
    this.setState({loading: true});
    if (typeof $ === 'undefined') {
      $ = jQuery;
    }
    if (
      (parseInt($("#global_lines_weight"+order_id).val(), 10) <= 0 || isNaN(parseInt($("#global_lines_weight"+order_id).val(), 10)))
    ) {
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.error_weight'), true);
    } else {
      var weight = parseInt($("#global_lines_weight"+order_id).val(), 10);
      /* We retrieve each fulfillabel quantity */
      var items = $( "input[name^='fulfillable[" + order_id + "]" ).serializeArray();
      var itemsFulfilled = {};

      $(items).each(function(i, field){
        if (parseInt(field.value, 10) > 0) {
          var product_id = field.name.match(/\[(.*?)\]/ig);
          product_id = product_id[1].replace(/[[\]]/g,'');
          // var productContent = [];
          // productContent['item_id'] = product_id;
          // productContent['qty_fulfilled'] = field.value;
          // itemsFulfilled.push(productContent);
          itemsFulfilled[product_id] = parseInt(field.value, 10);
        }
      });

      if (itemsFulfilled <= 0) {
        this.setState({loading: false});
        this.props.toggleToast(I18n.t('order_list.error_partial_quantity'), true);
      } else {
        axios({
          method: 'post',
          url: '/generate-label-partial',
          data: {
            order_id: order_id,
            weight: parseInt($("#global_lines_weight"+order_id).val(), 10),
            insurance: $("#insurance"+order_id).is(":checked"),
            is_return: $("#return"+order_id).is(":checked"),
            non_machinable: $("#machinable"+order_id).is(":checked"),
            ftd: $("#ftd"+order_id).is(":checked"),
            partial: true,
            label_id: false,
            item_fulfilled: itemsFulfilled,
            instance_id: this.props.shop.instance_id
          }
        }).then(result => {
          this.setState({loading: false});
          if (result.data.success == true) {
            this.props.toggleToast(result.data.response_ws.message, false);
            this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
            this.handleToggleSheet(order_id, 'labels');
          } else {
            this.props.toggleToast(result.data.response_ws.message, true);
            this.handleToggleSheet(order_id, 'labels');
          }
        }).catch(error => {
          console.log(error);
          this.props.toggleToast(I18n.t('order_list.error_generate_label'), true);
          this.setState({loading: false});
          this.handleToggleSheet(order_id, 'labels');
        });
      }
    }
  };

  generateBulkLabel = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});
    var error_weight = false;
    const items = this.state.selectedItems;
    this.setState({modalBulkGenerate: false});
    if (typeof $ === 'undefined') {
      $ = jQuery;
    }
    items.forEach((item) => {
      /* We verify if all weight are set */
      if (
        (parseInt($("#weight"+item).val(), 10) <= 0 || isNaN(parseInt($("#weight"+item).val(), 10)))
      ) {
        error_weight = true;
      }
    });

    if (error_weight === false) {
      /* We generate label in mass */
      var error_content = '';

      /* Impression automatique après génération : la fenêtre doit être ouverte pendant
         le clic. Elle patiente pendant la génération, puis reçoit toutes les étiquettes
         d'un coup — une seule fenêtre pour tout le lot. */
      const printSession = (this.props.config.use_thermal_printer == true && this.props.config.generate_and_print == true)
        ? this.openPrintSession()
        : null;
      const generated = new Set();

      /* Le `return` est indispensable : sans lui Promise.all ne reçoit que des undefined
         et se résout avant la fin des générations. */
      Promise.all(items.map(item => {
        return axios({
          method: 'post',
          url: '/generate-label',
          data: {
            order_id: item,
            weight: parseInt($("#weight"+item).val(), 10),
            insurance: $("#insurance"+item).is(":checked"),
            is_return: $("#return"+item).is(":checked"),
            non_machinable: $("#machinable"+item).is(":checked"),
            ftd: $("#ftd"+item).is(":checked"),
            partial: false,
            label_id: false,
            bulk_action: true,
            instance_id: this.props.shop.instance_id
          }
          }).then(result => {
            if (result.data.success == true) {
              generated.add(item);
            } else {
              error_content += result.data.response_ws.message;
            }
        }).catch(error => {
          error_content += I18n.t('order_list.error_generate_label');
          console.log(error);
        });
      })).then(() => {
        if (printSession) {
          const printable = items.filter((item) => generated.has(item));
          if (printable.length) {
            printSession.send({
              protocole: this.props.config.usb_protocole,
              requests: printable.map((item) => '/colissimo-label-by-order/'+item+'/'+this.props.shop.instance_id)
            });
          } else {
            printSession.cancel(I18n.t('order_list.error_generate_label'));
          }
        }
        if (error_content != '') {
          this.props.toggleToast(error_content, true);
        } else {
          this.props.toggleToast(I18n.t('order_list.success_bulk'), false);
        }
        this.setState({loading: false}, () => {
          console.log('call orders-filters here');
          this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit, items);
        });
      });
    } else {
      /* If there is Weight error */
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('order_list.error_weight_bulk'), true);
      this.setState({selectedItems : items});
    }
  };

  generateLabelReturn = (order_id, partial = false, label_id = false, regenerate = false) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});
    if (typeof $ === 'undefined') {
      $ = jQuery;
    }
    /* We verify if weight is set */
    if (
        (parseInt($("#weight"+order_id).val(), 10) <= 0 || isNaN(parseInt($("#weight"+order_id).val(), 10)))
    ) {
        this.setState({loading: false});
        this.props.toggleToast(I18n.t('order_list.error_weight'), true);
    } else {
        var weight = parseInt($("#weight"+order_id).val(), 10);
        axios({
            method: 'post',
            url: '/generate-label-return',
            data: {
                order_id: order_id,
                weight: weight,
                insurance: this.state["insurance"+order_id],
                is_return: this.state["return"+order_id],
                non_machinable: this.state["machinable"+order_id],
                ftd: this.state["ftd"+order_id],
                partial: partial,
                label_id: label_id,
                instance_id: this.props.shop.instance_id
            }
        }).then(result => {
            this.setState({loading: false});
            if (result.data.success == true) {
              this.props.toggleToast(result.data.response_ws.message, false);
            } else {
              this.props.toggleToast(result.data.response_ws.message, true);
            }
            if (!regenerate) {
                this.getLabelsRequest(order_id);
            } else {
                this.getLabelsRequest(order_id);
            }
        }).catch(error => {
            console.log(error);
            this.setState({loading: false});
            this.props.toggleToast(I18n.t('order_list.error_generate_label'), true);
        });
    }
  };

  /* L'impression thermique passe par une fenêtre top-level : l'iframe Wix ne reçoit
     pas les permissions réseau local, QZ Tray y est injoignable (cf. printWindow.js).
     La fenêtre doit être ouverte dans le clic, avant tout appel réseau. */
  openPrintSession = () => {
    const session = openPrintWindow();
    if (!session) {
      this.props.toggleToast(I18n.t('order_list.error_print_popup_blocked'), true);
      return null;
    }
    session.promise.catch((error) => {
      if (error && error.code === PRINT_WINDOW_CLOSED) return; /* fermée par l'utilisateur */
      this.props.toggleToast(I18n.t('order_list.error_print_bulk_label'), true);
    });
    return session;
  };

  printThermal = (requests) => {
    const session = this.openPrintSession();
    if (session) {
      session.send({ protocole: this.props.config.usb_protocole, requests: requests });
    }
  };

  printLabel = (id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.printThermal(['/colissimo-label/'+id+'/'+this.props.shop.instance_id]);
  };

  printLabelByOrder = (id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.printThermal(['/colissimo-label-by-order/'+id+'/'+this.props.shop.instance_id]);
  };

  regenerateLabel = (order_id, label_id) => {
    this.setState({regenerate_current_order_id: order_id});
    this.setState({regenerate_current_label_id: label_id});
    this.setState({modalRegenerate: true});
  };

  regenerateLabelReturn = (order_id, label_id) => {
    this.setState({regenerate_current_order_id: order_id});
    this.setState({regenerate_current_label_id: label_id});
    this.setState({modalRegenerateReturn: true});
    this.props.returnOrderListActiveModal(order_id, label_id, true);
  };

  generateBulkLabelCheckModal = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    var error_weight = false;
    const items = this.state.selectedItems;
    if (typeof $ === 'undefined') {
        $ = jQuery;
    }
    items.forEach((item) => {
      /* We verify if all weight are set */
      if (
        (parseInt($("#weight"+item).val(), 10) <= 0 || isNaN(parseInt($("#weight"+item).val(), 10)))
      ) {
        error_weight = true;
      }
    });

    if (error_weight === false) {
      this.setState({modalBulkGenerate: true});
    } else {
        /* If there is Weight error */
        this.setState({loading: false});
        this.props.toggleToast(I18n.t('order_list.error_weight_bulk'), true);
    }
  }

  deleteBulkOrder = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }

    this.setState({loading: true});
    this.setState({modalOpenOrderlistBuklDelete: false});
    const items = this.state.selectedItems;

    axios({
        method: 'post',
        url: '/delete-bulk-orders',
        data: {
            order_ids: items,
            instance_id: this.props.shop.instance_id
        }
    }).then(result => {
        this.setState({loading: false});
        if (result.data.success == true) {
          this.props.toggleToast(I18n.t('order_list.confirm_delete_order'), false);
        } else {
          this.props.toggleToast(I18n.t('order_list.error_delete_order'), true);
        }
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
    }).catch(error => {
        console.log(error);
        this.setState({loading: false});
        this.props.toggleToast(I18n.t('order_list.error_delete_order'), true);
    });
  }

  printBulkLabel = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    const items = (this.state.sortValue == 'DESC' ? this.state.selectedItems.sort().reverse() : this.state.selectedItems.sort());
    const thermal = this.props.config.use_thermal_printer == true;

    /* La fenêtre d'impression doit être ouverte pendant le clic, donc avant la
       vérification : on l'annule ensuite si les étiquettes ne sont pas toutes générées. */
    const session = thermal ? this.openPrintSession() : null;
    if (thermal && !session) {
      return;
    }

    /* We verify if all labels generate */
    axios({
        method: 'post',
        url: '/verify-label-exists',
        data: {
          order_ids: items,
          instance_id: this.props.shop.instance_id
        }
    }).then(result => {
        if (result.data.success != true) {
          if (session) session.cancel(I18n.t('order_list.error_print_bulk_label'));
          this.props.toggleToast(I18n.t('order_list.error_print_bulk_label'), true);
          return;
        }

        if (session) {
          session.send({
            protocole: this.props.config.usb_protocole,
            requests: items.map((item) => '/colissimo-print-bulk-label/'+item+'/'+this.props.shop.instance_id)
          });
        } else {
          window.open('/colissimo-print-bulk-label/'+items+'/'+this.props.shop.instance_id, '_blank');
        }
    }).catch(error => {
        console.log(error);
        if (session) session.cancel(I18n.t('order_list.error_print_bulk_label'));
        this.props.toggleToast(I18n.t('order_list.error_print_bulk_label'), true);
    });
  };

  printBulkReturnLabel = () => {
    const items = this.state.selectedItems;
    window.open('/colissimo-print-bulk-return-label/'+items+'/'+this.props.shop.instance_id,'_blank');
  };

  handleRemove = (key) => {
    if (key === 'date_to' || key === 'date_from') {
      this.setState({[key]: null}, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    } else {
      this.setState({[key]: []}, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }
  };

  handleClear = (type) => {
    if (type === 'date') {
      this.setState({
        [type]: [],
        date_to: null,
        date_from: null,
      }, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    } else {
      this.setState({
        [type]: [],
      }, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }
  }

  handleChangePage = (value) => {
    this.setState({
      page: value,
    }, () => {
      this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
    });
  }

  handleClearAll = () => {
    this.setState({
      paymentStatus: [],
      labelStatus: [],
      closedStatus: null,
      errorStatus: [],
      printedStatus: [],
      queryValue: null,
      fulfillmentStatus: [],
      weight: null,
      date: [],
      date_to: null,
      date_from: null,
      countries: [],
      services: [],
      selectedTabConfig: 0,
    }, () => {
      this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
    });
  };

  /* Filter order */
  callRequest = (url, items = false, silent = false) => {
    // `silent` : rafraîchissement discret, sans la modale de chargement.
    // Cette modale capte le focus du navigateur ; ouverte pendant une
    // recherche, elle le retirait du champ à chaque requête et rendait la
    // frappe impossible à enchaîner.
    this.setState({selectedItems : []});
    /*$('html, body').animate({scrollTop: 0}, 10);*/
    if (!silent) { this.setState({loading: true}); }
    console.log(this.state.queryValue);
    axios.get(url, {
      params: {
        queryValue: this.state.queryValue,
        paymentStatus: this.state.paymentStatus,
        printedStatus: this.state.printedStatus,
        fulfillmentStatus: this.state.fulfillmentStatus,
        labelStatus: this.state.labelStatus,
        closedStatus: this.state.closedStatus,
        errorStatus: this.state.errorStatus,
        weight: this.state.weight,
        date: this.state.date,
        date_from: this.state.date_from,
        date_to: this.state.date_to,
        countries: this.state.countries,
        services: this.state.services,
        sortable: this.state.sortValue,
        instance_id: this.props.shop.instance_id
      },
    }).then(result => {
      this.setState({orders: result.data.orders});
      this.setState({page: result.data.page});
      this.setState({page_limit: result.data.page_limit});
      this.setState({total_page: result.data.total_page});
      this.setState({count_orders: result.data.count_orders});
      if (!silent) { this.setState({loading: false}); }
      if (items !== false) {
        this.setState({selectedItems : items});
      }
    }).catch(error => {
      console.log(error);
      if (!silent) { this.setState({loading: false}); }
    });
  }

  handleTabChange = (selectedTabIndex) => {
    this.setState({ selectedTabConfig: selectedTabIndex.id });
    this.setState({
      paymentStatus: [],
      printedStatus: [],
      labelStatus: [],
      closedStatus: null,
      queryValue: null,
      fulfillmentStatus: [],
      weight: null,
      date: [],
      date_to: null,
      date_from: null,
      countries: [],
      services: [],
      errorStatus: [],
    }, () => {
      if (selectedTabIndex.id == 0) {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      }
    });

    if (selectedTabIndex.id == 1) {
      this.setState({ ['labelStatus']: ['unavailable'] }, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }

    if (selectedTabIndex.id == 2) {
      this.setState({ ['labelStatus']: ['available'] }, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }

    if (selectedTabIndex.id == 3) {
      this.setState({ ['fulfillmentStatus']: ['NOT_FULFILLED', 'PARTIALLY_FULFILLED'] }, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }

    if (selectedTabIndex.id == 4) {
      this.setState({ ['errorStatus']: ['error'] }, () => {
        this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }
  };


  /* Options de livraison proposées pour une commande, selon le pays
     destinataire. Extrait de `renderSheetChange` parce que la cotation doit
     porter sur EXACTEMENT les options affichées : une liste recalculée
     séparément finirait par diverger, et le marchand verrait un prix en face
     d'une option qui n'est pas celle cotée. */
  buildDeliveryOptions = (country_code) => {
    const pickup_point_available = this.props.pickup_point_available.indexOf(country_code) !== -1;
    const without_sign_country = this.props.without_sign_country.indexOf(country_code) !== -1;
    const is_outre_mer = this.props.iso_outre_mer.indexOf(country_code) !== -1 || this.props.iso_outre_mer2.indexOf(country_code) !== -1;
    const code_sign = is_outre_mer ? 'CDS' : 'DOS';
    const colissimo_international = this.props.iso_no_worldwide.indexOf(country_code) === -1;

    let options = [];

    if (!colissimo_international) {
      options.push({label: I18n.t('order_list.sheet.with_sign'), value: code_sign});
      if (without_sign_country) {
        options.push({label: I18n.t('order_list.sheet.without_sign'), value: 'DOM'});
      }
      if (pickup_point_available) {
        options.push({label: I18n.t('order_list.sheet.with_pickup'), value: 'PICKUP'});
      }
    } else {
      options.push({label: I18n.t('order_list.sheet.colissimo_international'), value: 'COLI'});
    }

    if (is_outre_mer) {
      options.push({label: I18n.t('order_list.sheet.colissimo_eco'), value: 'ECO'});
    }

    return options;
  };

  /* Poids (grammes) sur lequel coter, avec la même règle que le volet
     Étiquettes : poids de la commande + tare d'emballage, à défaut le poids
     par défaut du marchand. Coter un autre poids que celui qui sera affranchi
     donnerait un prix que la facture Colissimo ne confirmerait pas. */
  cotationWeightFor = (order) => {
    const tare = this.props.config ? (this.props.config.packing_tare ? parseInt(this.props.config.packing_tare) : 0) : 0;
    const total_weight = order ? parseFloat(order.total_weight) : NaN;

    if (!isNaN(total_weight) && total_weight > 0) {
      return Math.round(total_weight * 1000 + tare);
    }

    return this.props.config ? parseInt(this.props.config.default_weight) : 1000;
  };

  /* Interroge l'API de cotation Colissimo pour les options d'une commande.
     Silencieux en erreur : le prix est un confort d'affichage, son absence ne
     doit jamais empêcher le marchand de changer de mode de livraison. */
  getCotationPreview = (order_id, services, weight = null) => {
    if (!services || services.length === 0) {
      this.setState({cotationPrices: {}});
      return;
    }

    this.setState({cotationLoading: true});
    axios({
      method: 'post',
      url: '/cotation-preview',
      data: {
        order_id: order_id,
        services: services,
        weight: weight,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({
        cotationPrices: (result.data && result.data.prices) ? result.data.prices : {},
        cotationLoading: false
      });
    }).catch(error => {
      console.log(error);
      this.setState({cotationPrices: {}, cotationLoading: false});
    });
  };

  renderSheetChange = (order) => {
    const sheetActive = this.state.sheetActive;
    const {
      id,
      wix_order_number,
      payment_status,
    } = order.order

    const {
      address1,
      address2,
      city,
      company,
      country,
      first_name,
      last_name,
      phone,
      country_code,
      zip
    } = order.order_shipping

    const pickup_point = order.pickup_point

    //console.log(order.order_shipping_line[0]);
    const order_shipping_line = (order.order_shipping_line[0] ? order.order_shipping_line[0] : false);

    const product_code = order.product_code

    const myOptions = this.buildDeliveryOptions(country_code);

    /* Tarifs cotés pour cette commande. `false` = cotation pas encore
       revenue : on n'affiche alors rien plutôt qu'un montant provisoire. */
    const cotationPrices = this.state.cotationPrices || {};

    const renderCheckboxes = myOptions.map((item) => {
        var checked = false;
        if (!this.state.colissimo_service && pickup_point !== false) {
          if (item.value == 'PICKUP') {
            checked = true;
          }
        } else {
          if (this.state.colissimo_service  && this.state.colissimo_service == item.value) {
            checked = true;
          } else if (!this.state.colissimo_service) {
            if (product_code == item.value) {
              checked = true;
            }
          }
        }

        /* Prix HT (et TTC dérivé) du service, accolé au libellé de l'option.
           Absent tant que la cotation n'a pas répondu, ou si Colissimo ne
           propose pas ce service pour la destination — mieux vaut pas de
           prix qu'un prix qui ne sera pas facturé. */
        const price = cotationPrices[item.value] && cotationPrices[item.value].amount_total_ht;
        const label = (
          <Box direction="horizontal" gap="6px" verticalAlign="middle">
            <Text size="small">{item.label}</Text>
            {price != null &&
              <Text size="tiny" skin="success" weight="bold">
                {formatPrice(price, 'HT')}
              </Text>
            }
            {price != null &&
              <Text size="tiny" skin="disabled">
                {formatPrice(price * VAT_RATE, 'TTC')}
              </Text>
            }
          </Box>
        );

        return (
          <Radio key={item.value} name="colissimo_service" label={label} value={item.value} checked={checked} onChange={() => this.handleChangeWithValue("colissimo_service", item.value)} />
        );
      });

    var payment_status_badge = '';

    if (payment_status == 'PARTIALLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="general" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="success" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'FULLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="neutral" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PENDING') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="warning" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'NOT_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="danger" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PARTIALLY_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="urgent" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'UNSPECIFIED_PAYMENT_STATUS') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="standard" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    }

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: `${sheetActive ? 0 : -440}px`,
          height: '100%',
          boxShadow:
            '0 3px 24px 0 rgba(22, 45, 61, 0.18), 0 8px 8px 0 rgba(22, 45, 61, 0.12)',
          transition: 'right 0.4s ease 0s',
          zIndex: 2000,
        }}
      >
        <SidePanel title="Filter" onCloseButtonClick={this.handleCloseSheet}>
          <SidePanel.Header title={payment_status_badge} showDivider={true} />
          <SidePanel.Content>
            <Box direction="vertical" gap="18px">
              <Heading size="small">{I18n.t('order_list.sheet.carrier')}</Heading>
              <Text size="small" secondary>{order_shipping_line && order_shipping_line.delivery_option}</Text>
              <Divider />
              <Heading size="small">{I18n.t('order_list.sheet.address')}</Heading>
              {pickup_point === false &&
                <Text size="small">
                  <div>{first_name && first_name}&nbsp;{last_name && last_name}</div>
                  {company && <div>{company}</div>}
                  {address1 && <div>{address1}</div>}
                  {address2 && <div>{address2}</div>}
                  {zip && <div>{zip} {city}</div>}
                  {country && <div>{country}</div>}
                  {phone && <div>{phone}</div>}
                  <TextButton size="tiny" onClick={(e) => this.changeAddress(order.order_shipping)}>{I18n.t('order_list.change')}</TextButton>
                </Text>
              }
              {pickup_point !== false &&
                <Text size="small">
                  <div><b>{I18n.t('order_list.pickup_point_number')} {pickup_point.colissimo_id}</b></div>
                  <div>{first_name && first_name}&nbsp;{last_name && last_name}</div>
                  {pickup_point.company_name && <div>{pickup_point.company_name}</div>}
                  {pickup_point.address1 && <div>{pickup_point.address1}</div>}
                  {pickup_point.address2 && <div>{pickup_point.address2}</div>}
                  {pickup_point.zipcode && <div>{pickup_point.zipcode} {pickup_point.city}</div>}
                  {pickup_point.country && <div>{pickup_point.country}</div>}
                  {pickup_point.phone && <div>{pickup_point.phone}</div>}
                  <TextButton size="tiny" onClick={(e) => this.changeAddressPickup(pickup_point)}>{I18n.t('order_list.change_pickup_info')}</TextButton>
                  <TextButton size="tiny" onClick={(e) => this.changeService(id, order.order_shipping, 'PICKUP')}>{I18n.t('order_list.change_pickup')}</TextButton>
                </Text>
              }
              <Divider />
              <Heading size="small">{I18n.t('order_list.sheet.change_service')}</Heading>
              <Text size="small">{I18n.t('order_list.sheet.choose_service')}</Text>
              {this.state.cotationLoading &&
                <Text size="tiny" skin="disabled">{I18n.t('order_list.sheet.cotation_loading')}</Text>
              }
              {!this.state.cotationLoading && Object.keys(cotationPrices).length > 0 &&
                <Text size="tiny" skin="disabled">{I18n.t('order_list.sheet.cotation_estimate')}</Text>
              }
              <div>
                {renderCheckboxes}
                <input type="hidden" id="order-update-webservice" value={id} />
              </div>
              {this.state.colissimo_service &&
                <Button size="tiny" primary={true} onClick={(e) => this.changeService(id, order.order_shipping, (this.state.colissimo_service ? this.state.colissimo_service : (product_code ? product_code : '')))}>{I18n.t('order_list.sheet.save_service')}</Button>
              }
            </Box>
          </SidePanel.Content>
        </SidePanel>
      </div>
    );
  };

  renderSheetChangeOffer = (order) => {
    const sheetActive = this.state.sheetActive;
    const {
      id,
      wix_order_number,
      payment_status,
    } = order.order

    const {
      address1,
      address2,
      city,
      company,
      country,
      first_name,
      last_name,
      phone,
      country_code,
      zip
    } = order.order_shipping

    const pickup_point = order.pickup_point

    var payment_status_badge = '';

    if (payment_status == 'PARTIALLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="general" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="success" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'FULLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="neutral" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PENDING') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="warning" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'NOT_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="danger" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PARTIALLY_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="urgent" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'UNSPECIFIED_PAYMENT_STATUS') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="standard" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    }

    //console.log(order.order_shipping_line[0]);
    const order_shipping_line = (order.order_shipping_line[0] ? order.order_shipping_line[0] : false);

    const code_offer = (order.code_offer == '0' ? 'DPD' : 'LOCAL');

    const img_dpd = <img src={dpd} width="40px" />

    switch (country_code) {
        case 'DE':
            var icon_offer = <img src={germany} width="80px" />;
            break;
        case 'AT':
            var icon_offer = <img src={austria} width="80px" />;
            break;
        case 'IT':
            var icon_offer = <img src={italy} width="80px" />;
            break;
        case 'LU':
            var icon_offer = <img src={luxembourg} width="27px" />;
            break;
        default:
            var icon_offer = <img src={dpd} width="40px" />;
    }

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: `${sheetActive ? 0 : -440}px`,
          height: '100%',
          boxShadow:
            '0 3px 24px 0 rgba(22, 45, 61, 0.18), 0 8px 8px 0 rgba(22, 45, 61, 0.12)',
          transition: 'right 0.4s ease 0s',
          zIndex: 2000,
        }}
      >
        <SidePanel title="Filter" onCloseButtonClick={this.handleCloseSheet}>
          <SidePanel.Header title={payment_status_badge} showDivider={true} />
          <SidePanel.Content>
            <Box direction="vertical" gap="18px">
              <Heading size="small">{I18n.t('order_list.sheet.carrier')}</Heading>
              <Text size="small" secondary>{order_shipping_line && order_shipping_line.delivery_option}</Text>
              <Divider />
              <Heading size="small">{I18n.t('order_list.sheet.address')}</Heading>
              {pickup_point === false &&
                <Text size="small">
                  <div>{first_name && first_name}&nbsp;{last_name && last_name}</div>
                  {company && <div>{company}</div>}
                  {address1 && <div>{address1}</div>}
                  {address2 && <div>{address2}</div>}
                  {zip && <div>{zip} {city}</div>}
                  {country && <div>{country}</div>}
                  {phone && <div>{phone}</div>}
                  <TextButton size="tiny" onClick={(e) => this.changeAddress(order.order_shipping)}>{I18n.t('order_list.change')}</TextButton>
                </Text>
              }
              {pickup_point !== false &&
                <Text size="small">
                  <div><b>{I18n.t('order_list.pickup_point_number')} {pickup_point.colissimo_id}</b></div>
                  <div>{first_name && first_name}&nbsp;{last_name && last_name}</div>
                  {pickup_point.company_name && <div>{pickup_point.company_name}</div>}
                  {pickup_point.address1 && <div>{pickup_point.address1}</div>}
                  {pickup_point.address2 && <div>{pickup_point.address2}</div>}
                  {pickup_point.zipcode && <div>{pickup_point.zipcode} {pickup_point.city}</div>}
                  {pickup_point.country && <div>{pickup_point.country}</div>}
                  {pickup_point.phone && <div>{pickup_point.phone}</div>}
                  <TextButton size="tiny" onClick={(e) => this.changeAddressPickup(pickup_point)}>{I18n.t('order_list.change_pickup_info')}</TextButton>
                  <TextButton size="tiny" onClick={(e) => this.changeService(id, order.order_shipping, 'PICKUP')}>{I18n.t('order_list.change_pickup')}</TextButton>
                </Text>
              }
              <Divider />
              <Heading size="small">{I18n.t('order_list.sheet.change_service')}</Heading>
              <Text size="small">{I18n.t('order_list.sheet.choose_service')}</Text>
              <div>
                <Radio name="colissimo_service" label={img_dpd} value='DPD' checked={!this.state.colissimo_international_offer ? (code_offer ? (code_offer == 'DPD' ? true : false) : true) : (this.state.colissimo_international_offer == 'DPD' ? true :false)} onChange={() => this.handleChangeWithValue("colissimo_international_offer", 'DPD')} />
                <Radio name="colissimo_service" label={icon_offer} value='LOCAL' checked={!this.state.colissimo_international_offer ? (code_offer ? (code_offer == 'LOCAL' ? true : false) : false) : (this.state.colissimo_international_offer == 'LOCAL' ? true :false)} onChange={() => this.handleChangeWithValue("colissimo_international_offer", 'LOCAL')} />
                <input type="hidden" id="order-update-webservice" value={id} />
              </div>
              {this.state.colissimo_international_offer &&
                <Button size="tiny" primary={true} onClick={(e) => this.changeOffer(id, (this.state.colissimo_international_offer ? this.state.colissimo_international_offer : (code_offer ? code_offer : 'DPD')))}>{I18n.t('order_list.sheet.save_service')}</Button>
              }
            </Box>
          </SidePanel.Content>
        </SidePanel>
      </div>
    );
  };

  /* RENDER ORDER DETAIL */
  renderSheet = (order) => {
    const sheetActive = this.state.sheetActive;
    const {
      id,
      wix_order_number,
      payment_status,
      total_price,
      currency
    } = order.order

    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currency
    });

    const {
      address1,
      address2,
      city,
      company,
      country,
      first_name,
      last_name,
      phone,
      zip
    } = order.order_shipping || {}

    const order_lines = order.order_line_items

    const pickup_point = order.pickup_point

    const order_shipping_line = (order.order_shipping_line[0] ? order.order_shipping_line[0] : false);

    var payment_status_badge = '';

    if (payment_status == 'PARTIALLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="general" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="success" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'FULLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="neutral" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PENDING') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="warning" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'NOT_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="danger" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PARTIALLY_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="urgent" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'UNSPECIFIED_PAYMENT_STATUS') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="standard" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    }

    let sum = 0;
    const unfulfill_lines = order_lines.filter(line => (line.fulfillable_quantity !== 0 && payment_status != 'FULLY_REFUNDED')).map(line => {
      sum += parseFloat(parseFloat(line.weight * 1000) * parseInt((this.state["fulfillable["+id+"]["+line.id+"]"] ? this.state["fulfillable["+id+"]["+line.id+"]"] : line.fulfillable_quantity)));
      return (
        <Box direction="vertical" padding="SP2">
          <Text weight="bold" size="tiny">{line.name}</Text>
          <Text size="tiny">{formatter.format(`${line.price}`)} x {line.quantity} - {I18n.t('order_list.sheet.weight')} {parseFloat(line.weight * 1000) * parseInt(line.fulfillable_quantity)} {I18n.t('order_list.sheet.grams')}</Text>
          <Text weight="bold" size="tiny">SKU : {line.sku}</Text>
          <Box direction="vertical" paddingTop="SP2" paddingBottom="SP2">
            <Text size="small">{I18n.t('order_list.sheet.qty_to_fulfill')}</Text>
            <NumberInput
              name={`fulfillable[${id}][${line.id}]`}
              value={`${this.state["fulfillable["+id+"]["+line.id+"]"] ? this.state["fulfillable["+id+"]["+line.id+"]"] : line.fulfillable_quantity}`}
              onChange={this.handleChange(`fulfillable[${id}][${line.id}]`)}
              max={line.fulfillable_quantity} />
          </Box>
            <Divider />
        </Box>

      );
    });

    const fulfill_lines = order_lines.filter(line => (line.fulfillable_quantity === 0 || (line.quantity - line.fulfillable_quantity) > 0 || payment_status == 'FULLY_REFUNDED')).map(line => {
      return (
      <Box direction="vertical" padding="SP2">
        <Text weight="bold" size="tiny">{line.name}</Text>
        <Text size="tiny">{formatter.format(`${line.price}`)} x {line.quantity}</Text>
        <Text weight="bold" size="tiny">SKU : {line.sku}</Text>
        <Box direction="vertical" paddingTop="SP2">
          <Badge skin="success">{I18n.t('order_list.sheet.qty_fulfilled_refunded')} {line.quantity - line.fulfillable_quantity}</Badge>
        </Box>
        <Box direction="vertical" paddingTop="SP2" paddingBottom="SP2">
          <Divider />
        </Box>
      </Box>
      );
    });

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: `${sheetActive ? 0 : -440}px`,
          height: '100%',
          boxShadow:
            '0 3px 24px 0 rgba(22, 45, 61, 0.18), 0 8px 8px 0 rgba(22, 45, 61, 0.12)',
          transition: 'right 0.4s ease 0s',
          zIndex: 2000,
        }}
      >
        <SidePanel title="Filter" onCloseButtonClick={this.handleCloseSheet}>
          <SidePanel.Header title={payment_status_badge} showDivider={true} />
          <SidePanel.Content>
            <Box direction="vertical" gap="18px">
              <Heading size="small">{I18n.t('order_list.sheet.carrier')}</Heading>
              <Text size="small" secondary>{order_shipping_line && order_shipping_line.delivery_option}</Text>
              <Divider />
              <Heading size="small">{I18n.t('order_list.sheet.address')}</Heading>
              {pickup_point === false &&
                <Text size="small">
                  <div>{first_name && first_name}&nbsp;{last_name && last_name}</div>
                  {company && <div>{company}</div>}
                  {address1 && <div>{address1}</div>}
                  {address2 && <div>{address2}</div>}
                  {zip && <div>{zip} {city}</div>}
                  {country && <div>{country}</div>}
                  {phone && <div>{phone}</div>}
                  <TextButton size="tiny" onClick={(e) => this.changeAddress(order.order_shipping)}>{I18n.t('order_list.change')}</TextButton>
                </Text>
              }
              {pickup_point !== false &&
                <Text size="small">
                  <div><b>{I18n.t('order_list.pickup_point_number')} {pickup_point.colissimo_id}</b></div>
                  <div>{first_name && first_name}&nbsp;{last_name && last_name}</div>
                  {pickup_point.company_name && <div>{pickup_point.company_name}</div>}
                  {pickup_point.address1 && <div>{pickup_point.address1}</div>}
                  {pickup_point.address2 && <div>{pickup_point.address2}</div>}
                  {pickup_point.zipcode && <div>{pickup_point.zipcode} {pickup_point.city}</div>}
                  {pickup_point.country && <div>{pickup_point.country}</div>}
                  {pickup_point.phone && <div>{pickup_point.phone}</div>}
                  <TextButton size="tiny" onClick={(e) => this.changeAddressPickup(pickup_point)}>{I18n.t('order_list.change_pickup_info')}</TextButton>
                  <TextButton size="tiny" onClick={(e) => this.changeService(id, order.order_shipping, 'PICKUP')}>{I18n.t('order_list.change_pickup')}</TextButton>
                </Text>
              }
              <Divider />
              {unfulfill_lines.length > 0 &&
                <Box direction="vertical">
                  <TableListHeader options={[{ value: I18n.t('order_list.sheet.unfulfill_product') }]} />
                  {unfulfill_lines}
                </Box>}
                {fulfill_lines.length > 0 &&
                  <Box direction="vertical">
                    <TableListHeader options={[{ value: I18n.t('order_list.sheet.fulfill_product') }]} />
                    {fulfill_lines}
                  </Box>
                }
                <Box direction="vertical" padding="SP2" backgroundColor="D60" color="D10">
                  <Text weight="bold" size="tiny">{`Total ${formatter.format(total_price)}`}</Text>
                </Box>

                {unfulfill_lines.length > 0 &&
                  <Box direction="vertical">
                    <Divider/>
                    <Box direction="vertical" paddingTop="SP4">
                      <Text size="small">{I18n.t('order_list.sheet.global_weight')}</Text>
                      <NumberInput
                        name={`global_lines_weight${id}`}
                        id={`global_lines_weight${id}`}
                        value={`${this.state["global_lines_weight"+id] ? this.state["global_lines_weight"+id] : sum}`}
                        onChange={this.handleChange(`global_lines_weight${id}`)}
                      />
                      <div>&nbsp;</div>
                      <Button onClick={(e) => this.generate_partial(id)}>
                          {I18n.t('order_list.sheet.generate_label_partial')}
                      </Button>
                    </Box>
                  </Box>
                }
            </Box>
          </SidePanel.Content>
        </SidePanel>
      </div>
    );
  };

  /* RENDER ORDER DETAIL */
  renderSheetLabels = (data) => {
    const sheetActive = this.state.sheetActive;
    const {
        id,
        wix_order_number,
        payment_status,
        total_weight,
        country_code,
    } = data.order[0]

    const options = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false,
      timeZone: this.props.shop.time_zone
    };

    const tare = this.props.config ? (this.props.config.packing_tare ? this.props.config.packing_tare : 0) : 0;
    const totalWeight = this.state["weight"+id] !== undefined ? this.state["weight"+id] : (parseFloat(total_weight) ? (parseFloat(total_weight) * 1000 + parseInt(tare)) : (this.props.config ? parseInt(this.props.config.default_weight) : 1000));
    const return_available = ((this.props.config !== null && this.props.config.sender_iso_country == 'FR' && this.props.iso_return_available.indexOf(country_code) === -1 && this.props.iso_fr.indexOf(country_code) === -1) || (this.props.config !== null && this.props.config.sender_iso_country != 'FR' && this.props.iso_dom_return_available.indexOf(country_code) === -1)) ? false : true;

    const labels_lines = data.labels.map(line => {
      return (
        <Box direction="vertical" padding="SP2">
          <Box>
            <Text>{I18n.t('order_list.sheet.tracking_number')}</Text>&nbsp;<Text weight="bold" skin={line.file_deleted != true  ? "success" : "error"}>{line.file_deleted == true ? <s>{line.shipping_number}</s> : line.shipping_number}</Text>
          </Box>
          <Text size="small" skin="disabled">{I18n.t('order_list.sheet.created_label')}{new Intl.DateTimeFormat('default', options).format(new Date(line.created_at))}</Text>
          {line.amount_total_ht != null &&
            <Tooltip content={`${I18n.t('order_list.sheet.cotation_quoted_at')}${line.cotation_at ? new Intl.DateTimeFormat('default', options).format(new Date(line.cotation_at)) : '-'}`}>
              <Box direction="horizontal" gap="6px">
                <Text size="small" skin="success" weight="bold">{formatPrice(line.amount_total_ht, 'HT')}</Text>
                <Text size="small" skin="disabled">{formatPrice(line.amount_total_ht * VAT_RATE, 'TTC')}</Text>
              </Box>
            </Tooltip>
          }
          {line.partial == true &&
            <Text size="small" skin="success">{I18n.t('order_list.sheet.partial_fulfilled')}</Text>
          }
          {line.print_at &&
            <Text size="small" skin="success">{I18n.t('order_list.sheet.print_at')}{new Intl.DateTimeFormat('default', options).format(new Date(line.print_at))}</Text>
          }
          {line.file_deleted == true &&
            <Text size="small" skin="error">{I18n.t('order_list.sheet.file_delete_at')}{new Intl.DateTimeFormat('default', options).format(new Date(line.updated_at))}</Text>
          }
          {line.cn23 == true && line.file_deleted != true &&
            <TextButton size="small" as="a" href={`/colissimo-label-cn23/${line.id}/${this.props.shop.instance_id}`} target="_blank">{I18n.t('order_list.print_cn23')}</TextButton>
          }
          {(line.file_deleted != true && line.coliship != true) &&
            <Box direction="vertical" paddingTop="SP2">
              <Box>
                <NumberInput
                  type="text"
                  size="small"
                  name={`weight${line.order_id}`}
                  id={`regenerate_weight${line.order_id}`}
                  value={isNaN(totalWeight) ? 1000 : parseInt(`${totalWeight}`)}
                  onChange={this.handleChange(`weight${line.order_id}`)}
                />
              </Box>
              <Box>
                <Text size="tiny">{I18n.t('order_list.label_weight')}</Text>
              </Box>
              <Box paddingTop="SP2">
                {( this.props.config.use_thermal_printer == true) &&
                  <Button
                  priority="secondary"
                  prefixIcon={<PrintSmall />}
                  onClick={(e) => this.printLabel(line.id)}
                >
                  {I18n.t('order_list.print')}
                </Button>
                }
                {( this.props.config.use_thermal_printer == false) &&
                  <Button
                    priority="secondary"
                    prefixIcon={<PrintSmall />}
                    as="a" href={`/colissimo-label/${line.id}/${this.props.shop.instance_id}`} target="_blank"
                  >
                    {I18n.t('order_list.print')}
                  </Button>
                }
                &nbsp;<Button
                  skin="standard"
                  prefixIcon={<ShippingSmall />}
                  onClick={(e) => {this.setState({modalRegenerate: true}); this.regenerateLabel(line.order_id,line.id)}}
                >
                  {I18n.t('order_list.regenerate')}
                </Button>
              </Box>
            </Box>
          }
          <Box paddingTop="SP2">
            <Divider />
          </Box>
        </Box>
      );
    });

    const labels_return_lines = data.labels_return.map(line => {
      return (
        <Box direction="vertical" padding="SP2">
          <Box>
            <Text>{I18n.t('order_list.sheet.tracking_number')}</Text>&nbsp;<Text weight="bold" skin={line.file_deleted != true  ? "success" : "error"}>&nbsp;{line.file_deleted == true ? <s>{line.shipping_number}</s> : line.shipping_number}</Text>
          </Box>
          <Text size="small" skin="disabled">{I18n.t('order_list.sheet.created_label')}{new Intl.DateTimeFormat('default', options).format(new Date(line.created_at))}</Text>
          {line.amount_total_ht != null &&
            <Tooltip content={`${I18n.t('order_list.sheet.cotation_quoted_at')}${line.cotation_at ? new Intl.DateTimeFormat('default', options).format(new Date(line.cotation_at)) : '-'}`}>
              <Box direction="horizontal" gap="6px">
                <Text size="small" skin="success" weight="bold">{formatPrice(line.amount_total_ht, 'HT')}</Text>
                <Text size="small" skin="disabled">{formatPrice(line.amount_total_ht * VAT_RATE, 'TTC')}</Text>
              </Box>
            </Tooltip>
          }
          {line.partial == true &&
            <Text size="small" skin="success">{I18n.t('order_list.sheet.partial_fulfilled')}</Text>
          }
          {line.print_at &&
            <Text size="small" skin="success">{I18n.t('order_list.sheet.print_at')}{new Intl.DateTimeFormat('default', options).format(new Date(line.print_at))}</Text>
          }
          {line.file_deleted == true &&
            <Text size="small" skin="error">{I18n.t('order_list.sheet.file_delete_at')}{new Intl.DateTimeFormat('default', options).format(new Date(line.updated_at))}</Text>
          }
          {line.cn23 == true && line.file_deleted != true &&
            <TextButton size="small" as="a" href={`/colissimo-label-cn23/${line.id}/${this.props.shop.instance_id}`} target="_blank">{I18n.t('order_list.print_cn23')}</TextButton>
          }
          {(line.file_deleted != true && line.coliship != true) &&
            <Box direction="vertical" paddingTop="SP2" paddingBottom="SP2">
              <Box>
                <NumberInput
                  type="text"
                  size="small"
                  name={`weight${line.order_id}`}
                  id={`regenerate_weight${line.order_id}`}
                  value={isNaN(totalWeight) ? 1000 : parseInt(`${totalWeight}`)}
                  onChange={this.handleChange(`weight${line.order_id}`)}
                />
              </Box>
              <Box>
                <Text size="tiny">{I18n.t('order_list.label_weight')}</Text>
              </Box>
              <Box paddingTop="SP2">
                <Button
                  priority="secondary"
                  prefixIcon={<PrintSmall />}
                  as="a" href={`/colissimo-label/${line.id}/${this.props.shop.instance_id}`} target="_blank"
                >
                  {I18n.t('order_list.print')}
                </Button>
                &nbsp;<Button
                  skin="standard"
                  prefixIcon={<ShippingSmall />}
                  onClick={(e) => {this.setState({modalRegenerateReturn: true}); this.regenerateLabelReturn(line.order_id,line.id)}}
                >
                  {I18n.t('order_list.regenerate')}
                </Button>
              </Box>
            </Box>
          }
          <Box paddingTop="SP2">
            <Divider />
          </Box>
        </Box>
      );
    });

    var payment_status_badge = '';

    if (payment_status == 'PARTIALLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="general" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="success" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'FULLY_REFUNDED') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="neutral" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PENDING') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="warning" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'NOT_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="danger" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'PARTIALLY_PAID') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="urgent" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    } else if (payment_status == 'UNSPECIFIED_PAYMENT_STATUS') {
      payment_status_badge = (<Box><Heading size="small">{I18n.t('order_list.sheet.title')} #{wix_order_number}</Heading>&nbsp;<Badge skin="standard" size="tiny">{I18n.t(`${payment_status}`)}</Badge></Box>);
    }

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: `${sheetActive ? 0 : -440}px`,
          height: '100%',
          boxShadow:
            '0 3px 24px 0 rgba(22, 45, 61, 0.18), 0 8px 8px 0 rgba(22, 45, 61, 0.12)',
          transition: 'right 0.4s ease 0s',
          zIndex: 2000,
        }}
      >
        <SidePanel title="Filter" onCloseButtonClick={this.handleCloseSheet}>
          <SidePanel.Header title={payment_status_badge} showDivider={true} />
          <SidePanel.Content>
            <Box direction="vertical" gap="18px">
                {data.labels.length > 0 &&
                  <Box direction="vertical">
                    <TableListHeader options={[{ value: I18n.t('order_list.sheet.labels') }]} />
                    {labels_lines}
                  </Box>
                }
                {data.labels.length <= 0 &&
                  <div>
                    <Box>
                      <NumberInput
                        type="text"
                        size="small"
                        name={`weight${id}`}
                        id={`weight${id}`}
                        value={isNaN(totalWeight) ? 1000 : (parseFloat(`${totalWeight}`)) }
                        onChange={this.handleChange(`weight${id}`)}
                      />
                    </Box>
                    <Box>
                      <Text size="tiny">{I18n.t('order_list.label_weight')}</Text>
                    </Box>
                    <Box paddingTop="SP2">
                      <Button
                        skin="standard"
                        prefixIcon={<ShippingSmall />}
                        onClick={(e) => this.generateLabel(id)}
                      >
                        {I18n.t('order_list.generate')}
                      </Button>
                    </Box>
                  </div>
                }
                {data.labels_return.length > 0 &&
                  <Box direction="vertical">
                    <TableListHeader options={[{ value: I18n.t('order_list.sheet.labels_return') }]} />
                    {labels_return_lines}
                  </Box>
                }
                {data.labels_return.length <= 0 &&
                  (return_available === true ? (
                    <div>
                      <Box>
                        <NumberInput
                          type="text"
                          size="small"
                          name={`weight${id}`}
                          id={`weight${id}`}
                          value={isNaN(totalWeight) ? 1000 : (parseFloat(`${totalWeight}`))}
                          onChange={this.handleChange(`weight${id}`)}
                        />
                      </Box>
                      <Box>
                        <Text size="tiny">{I18n.t('order_list.label_weight')}</Text>
                      </Box>
                      <Box paddingTop="SP2">
                        <Button
                          skin="standard"
                          prefixIcon={<ShippingSmall />}
                          onClick={(e) => this.generateLabelReturn(id)}
                        >
                          {I18n.t('order_list.generate_return')}
                        </Button>
                      </Box>
                    </div>) : (
                      <Box><Text variation="negative">{I18n.t('order_list.sheet.unavailable_return')}</Text></Box>
                  ))
                }
            </Box>
          </SidePanel.Content>
        </SidePanel>
      </div>
    );
  };

  renderColumnOrderNumber = (row) => {
    const {id, wix_order_number, payment_status, wix_order_created_at, commercial_name, error_generate_label, error_generate_label_message, number_label, country_code, province_code} = row;

    const options = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false,
      timeZone: this.props.shop.time_zone
    };

    const cn23 = ((this.props.config !== null && this.props.config.sender_iso_country == 'FR' && this.props.iso_eu_countries_no_cn23.indexOf(country_code) === -1 && this.props.iso_fr.indexOf(country_code) === -1) || (this.props.config !== null && this.props.config.sender_iso_country != 'FR' && this.props.iso_dom_countries_no_cn23.indexOf(country_code) === -1) || (this.props.config !== null && this.props.config.sender_iso_country == 'FR' && country_code == 'ES' && this.props.province_code_cn23.indexOf(province_code) > -1 )) ? (
      <Box verticalAlign="middle">
        <Text size="tiny" skin="error"><MapSmall /></Text>&nbsp;<Text size="tiny" skin="error">{I18n.t('order_list.cn23_alert')}</Text>
      </Box>) : null;

    return (
      <div>
        <Box gap="SP1" verticalAlign="middle">
          {error_generate_label === true &&
            <Tooltip content={error_generate_label_message}><StatusWarningFilled /></Tooltip>
          }
          <TextButton onClick={(e) => this.handleToggleSheet(id)}>#{wix_order_number}</TextButton>
          {payment_status == 'PARTIALLY_REFUNDED' && <Badge skin="general" size="tiny">
              {I18n.t(`${payment_status}`)}
          </Badge>}
          {payment_status == 'PAID' && <Badge skin="success" size="tiny">
              {I18n.t(`${payment_status}`)}
          </Badge>}
          {payment_status == 'FULLY_REFUNDED' && <Badge skin="neutral" size="tiny">
              {I18n.t(`${payment_status}`)}
          </Badge>}
          {payment_status == 'PENDING' && <Badge skin="warning" size="tiny">
              {I18n.t(`${payment_status}`)}
          </Badge>}
          {payment_status == 'NOT_PAID' && <Badge skin="danger" size="tiny">
              {I18n.t(`${payment_status}`)}
          </Badge>}
          {payment_status == 'PARTIALLY_PAID' && <Badge skin="urgent" size="tiny">
              {I18n.t(`${payment_status}`)}
          </Badge>}
          {payment_status == 'UNSPECIFIED_PAYMENT_STATUS' && <Badge skin="standard" size="tiny">
              {I18n.t(`${payment_status}`)}
          </Badge>}
        </Box>
        <Box>
          <Text size="tiny" skin="disabled">{new Intl.DateTimeFormat('default', options).format(new Date(wix_order_created_at))}</Text>
        </Box>
        <Box>
          <Text size="tiny"><span style={{color:'#F49342'}}>{commercial_name !== null && commercial_name !== '' ? commercial_name : I18n.t('order_list.no_colissimo_order')}</span> <TextButton size="tiny" onClick={(e) => this.handleToggleSheet(id, 'change')}>{I18n.t('order_list.change')}</TextButton></Text>
        </Box>
        {number_label > 0 &&
          <Box>
              <TextButton underline="always" prefixIcon={<DocumentSmall />} size="small" skin="premium" onClick={(e) => this.handleToggleSheet(id, 'labels')}>{I18n.t('order_list.label_available')}</TextButton>
          </Box>}
        {number_label == 0 &&
          cn23
        }
      </div>
    );
  }

  renderColumnCustomer = (row) => {
    const {id, full_name, email, product_code, country_code, international_offer} = row;

    if (this.props.config !== null && this.props.config.sender_iso_country == 'FR' && this.props.dpd_eligibility.indexOf(country_code) > -1 && product_code == 'DOS') {
      var icon_offer = <img src={dpd} width="40px" />;

      if (international_offer == '1') {
          switch (country_code) {
              case 'DE':
                  var icon_offer = <img src={germany} width="70px" />;
                  break;
              case 'AT':
                  var icon_offer = <img src={austria} width="70px" />;
                  break;
              case 'IT':
                  var icon_offer = <img src={italy} height="20px" />;
                  break;
              case 'LU':
                  var icon_offer = <img src={luxembourg} height="20px" />;
                  break;
              default:
                  var icon_offer = <img src={dpd} width="40px" />;
          }
      }
    }

    return (
      <div>
        <Box>
          <Text weight="bold" size="tiny">{full_name}</Text>
        </Box>
        <Box>
          <Text weight="thin" size="tiny">{email}</Text>
        </Box>
        {(this.props.config !== null && this.props.config.sender_iso_country == 'FR' && this.props.dpd_eligibility.indexOf(country_code) > -1 && product_code == 'DOS') &&
          <Box><Text weight="thin" size="tiny">via {icon_offer} <TextButton size="tiny" onClick={(e) => this.handleToggleSheet(id, 'change_offer')}>{I18n.t('order_list.change')}</TextButton></Text></Box>
        }
      </div>
    );
  }

  capitalize = (str) => {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1);
  }

  renderColumnFulfillment = (row) => {
    const {fulfillment_status, country_code, country} = row;

    return (
      <div>
        <Box align="center">
            {fulfillment_status == 'FULFILLED' && <Badge skin="neutral" size="tiny">
                {I18n.t(`${fulfillment_status}`)}
            </Badge>}
            {fulfillment_status == 'NOT_FULFILLED' && <Badge skin="warning" size="tiny">
                {I18n.t(`${fulfillment_status}`)}
            </Badge>}
            {fulfillment_status == 'CANCELED' && <Badge skin="danger" size="tiny">
                {I18n.t(`${fulfillment_status}`)}
            </Badge>}
            {fulfillment_status == 'PARTIALLY_FULFILLED' && <Badge skin="urgent" size="tiny">
                {I18n.t(`${fulfillment_status}`)}
            </Badge>}
        </Box>
        <Box align="center">
          {(typeof country != 'undefined' && country != null) ? (<Text size="tiny"><span style={{color:'#F49342'}}>{this.capitalize(country)}</span></Text>) : ('')}
        </Box>
        {(typeof country_code != 'undefined' && country_code != null) ? (<div style={{backgroundImage:`url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/${country_code.toLowerCase()}.svg)`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', height: '1em'}}></div>) : (' ')}
      </div>
    );
  }

  renderColumnWeight = (row) => {
    const {id, total_weight} = row;
    console.log(row);
    const tare = this.props.config ? (this.props.config.packing_tare ? this.props.config.packing_tare : 0) : 0;
    const totalWeight = this.state["weight"+id] !== undefined ? this.state["weight"+id] : (parseFloat(total_weight) ? (parseFloat(total_weight) * 1000 + parseInt(tare)) : (this.props.config ? parseInt(this.props.config.default_weight) : 1000));
    console.log('On vérifie le total weight --> ' + (parseFloat(total_weight)));
    console.log('On vérifie le weight --> ' + (parseFloat(total_weight) * 1000 + parseInt(tare)));
    return (
      <div>
        <Box>
          <NumberInput
            type="text"
            size="small"
            name={`weight${id}`}
            id={`weight${id}`}
            value={isNaN(totalWeight) ? 1000 : parseInt(`${totalWeight}`)}
            onChange={this.handleChange(`weight${id}`)}
          />
        </Box>
        <Box>
          <Text size="tiny">{I18n.t('order_list.label_weight')}</Text>
        </Box>
      </div>
    );
  }

  renderColumnActions = (row) => {
    const {id, number_label, fulfillment_status,coliship} = row;

    return (
      <div>
        {(number_label == 0 && fulfillment_status != 'FULFILLED') &&
          <Button
            skin="standard"
            size="small"
            prefixIcon={<ShippingSmall />}
            onClick={(e) => this.generateLabel(id)}
          >
            {I18n.t('order_list.generate')}
          </Button>
        }
        {(number_label == 0 && fulfillment_status == 'FULFILLED') &&
          <PopoverMenu
            textSize="small"
            triggerElement={
              <Tooltip content="More actions">
                <Button
                  skin="standard"
                  size="small"
                  suffixIcon={<ChevronDownLargeSmall />}
                >
                  {I18n.t('order_list.generate')}
                </Button>
              </Tooltip>
            }
          >
            <PopoverMenu.MenuItem
              text={I18n.t('order_list.generate_label')}
              prefixIcon={<ShippingSmall />}
              onClick={(e) => this.generateLabel(id)}
            />
            <PopoverMenu.MenuItem
              text={I18n.t('order_list.generate_return')}
              prefixIcon={<RedoSmall />}
              onClick={(e) => this.generateLabelReturn(id)}
            />
          </PopoverMenu>
        }
        {(number_label == 1 && coliship !== true) &&
          <div>
            {( this.props.config.use_thermal_printer == true) &&
              <Button
                priority="secondary"
                size="small"
                prefixIcon={<PrintSmall />}
                onClick={(e) => this.printLabelByOrder(id)}
              >
                {I18n.t('order_list.print')}
              </Button>
            }
            {( this.props.config.use_thermal_printer == false) &&
              <Button
                priority="secondary"
                size="small"
                prefixIcon={<PrintSmall />}
                as="a" href={`/colissimo-label-by-order/${id}/${this.props.shop.instance_id}`} target="_blank"
              >
                {I18n.t('order_list.print')}
              </Button>
            }
          </div>
        }
        {number_label > 1 &&
          <Button
            priority="secondary"
            size="small"
            prefixIcon={<PrintSmall />}
            onClick={(e) => this.handleToggleSheet(id, 'labels')}
          >
            {I18n.t('order_list.details')}
          </Button>
        }
      </div>
    );
  }

  renderColumnOptions = (row) => {
    const {id, country_code, product_code, total_price, height, width, length, description, insurance, insurance_return} = row;

    const checkedInsurance = this.state["insurance"+id] !== undefined ? this.state["insurance"+id] : (this.props.config ? (this.props.config.insure_shipments && total_price >= this.props.config.amount_to_insurance ? this.props.config.insure_shipments : false) : false);
    const checkedReturn = this.state["return"+id] !== undefined ? this.state["return"+id] : (this.props.config ? this.props.config.auto_print_return_label : false);
    const checkedMachinable = this.state["machinable"+id];
    const checkedFtd = this.state["ftd"+id];

    const ftd = this.props.iso_outre_mer.indexOf(country_code) === -1 ? false : true;

    if ((product_code == '' || product_code == null) && this.props.iso_no_worldwide.indexOf(country_code) === -1) {
        var productCode = 'COLI';
    } else if (product_code == '' || product_code == null) {
        var productCode = 'DOM'
    } else {
        var productCode = product_code;
    }

    const ddp = (this.props.delivery_duty_paid.indexOf(country_code) > -1 && (productCode == 'DOS' || productCode == 'COLI'))  ? true : false;

    const insurance_available = (this.props.insurable_products.indexOf(productCode) >= 0 || (productCode == 'DOS' && country_code == 'FR')) ? true : false;
    const return_available = ((this.props.config !== null && this.props.config.sender_iso_country == 'FR' && this.props.iso_return_available.indexOf(country_code) === -1 && this.props.iso_fr.indexOf(country_code) === -1) || (this.props.config !== null && this.props.config.sender_iso_country != 'FR' && this.props.iso_dom_return_available.indexOf(country_code) === -1)) ? false : true;

    const restrictedInsuranceProduct = ['BPR', 'A2P', 'BDP', 'CMT'].indexOf(productCode) !== -1;
    const insuranceAmountForOrder = total_price ? (Number(total_price) / 1.2) : 0;
    const defaultInsuranceValue = this.defaultInsuranceTier(insuranceAmountForOrder, restrictedInsuranceProduct);
    const persistedInsuranceValue = this.state["saved_insurance"+id] !== undefined ? this.state["saved_insurance"+id] : (insurance !== null && insurance !== undefined ? insurance : defaultInsuranceValue);
    const draftInsuranceValue = this.state["insurance_amount"+id] !== undefined ? this.state["insurance_amount"+id] : persistedInsuranceValue;

    const persistedInsuranceReturnValue = this.state["saved_insurance_return"+id] !== undefined ? this.state["saved_insurance_return"+id] : (insurance_return !== null && insurance_return !== undefined ? insurance_return : 0);
    const draftInsuranceReturnValue = this.state["insurance_return_amount"+id] !== undefined ? this.state["insurance_return_amount"+id] : persistedInsuranceReturnValue;

    return (
      <Box align="center">
        <Box direction="vertical" align="center">
          <Checkbox
            tooltipContent={I18n.t('order_list.insurance_tooltip')}
            tooltipProps={{
              placement: 'top-start',
              textAlign: 'start',
            }}
            checked={insurance_available ? checkedInsurance : false}
            id={`insurance${id}`}
            onChange={() => this.handleChangeWithValue(`insurance${id}`, !checkedInsurance)}
            disabled={!insurance_available}
          />
          {!insurance_available && (
            <div style={{textAlign: 'center'}}>
              <Text size="tiny" skin="disabled">{I18n.t('order_list.insurance_label')}</Text>
            </div>
          )}
          {insurance_available && (
          <Popover
            shown={!!this.state["activeinsurance"+id]}
            placement="bottom"
            onClickOutside={() => this.state["activeinsurance"+id] && this.closeInsurancePopover(id)}
            appendTo="window"
          >
            <Popover.Element>
              <div style={{textAlign: 'center', whiteSpace: 'nowrap'}}>
                {checkedInsurance ? (
                  <TextButton
                    size="tiny"
                    underline="always"
                    onClick={() => this.toggleActive(`activeinsurance${id}`)}
                  >
                    {I18n.t('order_list.insurance_label')} {persistedInsuranceValue} €
                  </TextButton>
                ) : (
                  <Text size="tiny" ellipsis>{I18n.t('order_list.insurance_label')} {persistedInsuranceValue} €</Text>
                )}
              </div>
            </Popover.Element>
            <Popover.Content>
              <Box direction="vertical" padding="SP3" gap="SP2" backgroundColor="white">
                <Text size="tiny" weight="bold">
                  {I18n.t('order_list.order_amount')} {insuranceAmountForOrder.toFixed(2)} € HT
                </Text>
                <RadioGroup
                  value={draftInsuranceValue}
                  onChange={(value) => this.handleChangeWithValue(`insurance_amount${id}`, value)}
                  disabledRadios={restrictedInsuranceProduct ? [2000, 5000] : []}
                >
                  <RadioGroup.Radio value={150}>150 € (+ 0,90 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={300}>300 € (+ 1,80 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={500}>500 € (+ 3,00 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={1000}>1000 € (+ 6,00 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={2000}>2000 € (+ 12,00 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={5000}>5000 € (+ 30,00 € HT)</RadioGroup.Radio>
                </RadioGroup>
                <Box direction="horizontal" gap="SP2" align="space-between">
                  <Button size="small" onClick={() => this.handleChangeInsurance(id)}>
                    {I18n.t('order_list.sheet.save_service')}
                  </Button>
                  <TextButton size="small" onClick={() => this.closeInsurancePopover(id)}>
                    {I18n.t('order_list.close_insurance')}
                  </TextButton>
                </Box>
              </Box>
            </Popover.Content>
          </Popover>
          )}
        </Box>
        <Box direction="vertical" align="center" paddingLeft="SP2">
          <Checkbox
            tooltipContent={I18n.t('order_list.return_tooltip')}
            tooltipProps={{
              placement: 'top-start',
              textAlign: 'start',
            }}
            checked={return_available ? checkedReturn : false}
            id={`return${id}`}
            onChange={() => this.handleChangeWithValue(`return${id}`, !checkedReturn)}
            disabled={!return_available}
          />
          <div style={{textAlign: 'center'}}>
            <Text size="tiny">{I18n.t('order_list.return_label')}</Text>
          </div>
          {!checkedReturn && (
            <div style={{textAlign: 'center', whiteSpace: 'nowrap'}}>
              <Text size="tiny" skin="disabled" ellipsis>{I18n.t('order_list.insurance_label')}{persistedInsuranceReturnValue > 0 ? ` ${persistedInsuranceReturnValue} €` : ''}</Text>
            </div>
          )}
          {checkedReturn && (
          <Popover
            shown={!!this.state["activeinsurancereturn"+id]}
            placement="bottom"
            onClickOutside={() => this.state["activeinsurancereturn"+id] && this.closeInsuranceReturnPopover(id)}
            appendTo="window"
          >
            <Popover.Element>
              <div style={{textAlign: 'center', whiteSpace: 'nowrap'}}>
                <TextButton
                  size="tiny"
                  underline="always"
                  onClick={() => this.toggleActive(`activeinsurancereturn${id}`)}
                >
                  {I18n.t('order_list.insurance_label')}{persistedInsuranceReturnValue > 0 ? ` ${persistedInsuranceReturnValue} €` : ''}
                </TextButton>
              </div>
            </Popover.Element>
            <Popover.Content>
              <Box direction="vertical" padding="SP3" gap="SP2" backgroundColor="white">
                <Text size="tiny" weight="bold">
                  {I18n.t('order_list.order_amount')} {insuranceAmountForOrder.toFixed(2)} € HT
                </Text>
                <RadioGroup
                  value={draftInsuranceReturnValue}
                  onChange={(value) => this.handleChangeWithValue(`insurance_return_amount${id}`, value)}
                >
                  <RadioGroup.Radio value={0}>{I18n.t('order_list.without_insurance')}</RadioGroup.Radio>
                  <RadioGroup.Radio value={150}>150 € (+ 0,90 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={300}>300 € (+ 1,80 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={500}>500 € (+ 3,00 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={1000}>1000 € (+ 6,00 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={2000}>2000 € (+ 12,00 € HT)</RadioGroup.Radio>
                  <RadioGroup.Radio value={5000}>5000 € (+ 30,00 € HT)</RadioGroup.Radio>
                </RadioGroup>
                <Box direction="horizontal" gap="SP2" align="space-between">
                  <Button size="small" onClick={() => this.handleChangeInsuranceReturn(id)}>
                    {I18n.t('order_list.sheet.save_service')}
                  </Button>
                  <TextButton size="small" onClick={() => this.closeInsuranceReturnPopover(id)}>
                    {I18n.t('order_list.close_insurance')}
                  </TextButton>
                </Box>
              </Box>
            </Popover.Content>
          </Popover>
          )}
        </Box>
        <Box direction="vertical" align="center" paddingLeft="SP2">
          <Checkbox
            tooltipContent={I18n.t('order_list.machinable_tooltip')}
            tooltipProps={{
              placement: 'top-start',
              textAlign: 'start',
            }}
            checked={checkedMachinable}
            id={`machinable${id}`}
            onChange={() => this.handleChangeWithValue(`machinable${id}`, !checkedMachinable)}
          />
          <div style={{textAlign: 'center'}}>
            <Text size="tiny">{I18n.t('order_list.machinable_label')}</Text>
          </div>
        </Box>
        {ftd === true ? (
          <Box direction="vertical" align="center" paddingLeft="SP2">
            <Checkbox
              tooltipContent={I18n.t('order_list.ftd_tooltip')}
              tooltipProps={{
                placement: 'top-start',
                textAlign: 'start',
              }}
              checked={checkedFtd}
              id={`ftd${id}`}
              onChange={() => this.handleChangeWithValue(`ftd${id}`, !checkedFtd)}
            />
            <div style={{textAlign: 'center'}}>
              <Text size="tiny">{I18n.t('order_list.ftd_label')}</Text>
            </div>
          </Box>
        ) : ''}
        {ddp === true ? (
          <div>
            <Modal
            isOpen={this.state["activeddp"+id]}
            onRequestClose={() => this.handleChangeWithValue(`activeddp${id}`)}
            shouldCloseOnOverlayClick
            screen="desktop"
          >
            <CustomModalLayout
              primaryButtonText={I18n.t('order_list.sheet.save_service')}
              secondaryButtonText={I18n.t('order_list.close_ddp')}
              onCloseButtonClick={() => this.handleChangeWithValue(`activeddp${id}`, false)}
              secondaryButtonOnClick={() => this.handleChangeWithValue(`activeddp${id}`, false)}
              primaryButtonOnClick={() => this.handleChangeDdp(id)}
              title={I18n.t('order_list.modal.ddp_title')}
              content={
                <Box direction="vertical" marginBottom="SP2">
                  <Layout>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t("order_list.label_width")}
                        required
                      >
                        <Input
                          type="text"
                          name={`width${id}`}
                          id={`width${id}`}
                          value={this.state["width"+id] !== undefined ? this.state["width"+id] : (width > 0 ? `${width}` : '')}
                          onChange={this.handleChangeDpd}
                        />
                      </FormField>
                    </Cell>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('order_list.label_height')}
                        required
                      >
                        <Input
                          type="text"
                          name={`height${id}`}
                          id={`height${id}`}
                          value={this.state["height"+id] !== undefined ? this.state["height"+id] : (height > 0 ? `${height}` : '')}
                          onChange={this.handleChangeDpd}
                        />
                      </FormField>
                    </Cell>
                  </Layout>
                  <br/>
                  <Layout>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t("order_list.label_length")}
                        required
                      >
                        <Input
                          type="text"
                          name={`length${id}`}
                          id={`length${id}`}
                          value={this.state["length"+id] !== undefined ? this.state["length"+id] : (length > 0 ? `${length}` : '')}
                          onChange={this.handleChangeDpd}
                        />
                      </FormField>
                    </Cell>
                    <Cell span={6}>
                      <FormField
                        label={I18n.t('order_list.label_description')}
                        required
                      >
                        <Input
                          type="text"
                          name={`description${id}`}
                          id={`description${id}`}
                          value={this.state["description"+id] !== undefined ? this.state["description"+id] : description}
                          onChange={this.handleChangeDpd}
                        />
                        <Text size="tiny">{I18n.t('order_list.helptext_description')}</Text>
                      </FormField>
                    </Cell>
                  </Layout>
                </Box>
              }
            ></CustomModalLayout>
          </Modal>
          <Box direction="vertical" align="center" paddingLeft="SP2">
            <Checkbox
              tooltipContent={I18n.t('order_list.ddp_tooltip')}
              tooltipProps={{
                placement: 'top-start',
                textAlign: 'start',
              }}
              checked={checkedFtd}
              id={`ftd${id}`}
              onChange={() => this.handleChangeWithValue(`ftd${id}`, !checkedFtd)}
            />
            <div style={{textAlign: 'center'}}>
              <Text size="tiny">{I18n.t('order_list.ddp_label')}</Text>
            </div>
          </Box>
          </div>
        ) : ''}

      </Box>
    );
  }

  reinitVars = () => {
    this.setState({modalRegenerate: false});
    this.setState({modalRegenerateReturn: false});
    this.setState({regenerate_current_order_id: null});
    this.setState({regenerate_current_label_id: null});
  }

  displayModalRegenerate = () => {
    return (
      <Modal
        isOpen={this.state.modalRegenerate}
        onRequestClose={() => this.reinitVars()}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
          primaryButtonText={I18n.t('order_list.modal.regenerate_ok_button')}
          secondaryButtonText={I18n.t('order_list.modal.cancel_button')}
          onCloseButtonClick={() => this.reinitVars()}
          secondaryButtonOnClick={() => this.reinitVars()}
          primaryButtonOnClick={() => this.generateLabel(this.state.regenerate_current_order_id, false, this.state.regenerate_current_label_id, true)}
          title={I18n.t('order_list.modal.regenerate_title')}
          content={
            <Box direction="vertical" marginBottom="SP2">
              <Text>{I18n.t('order_list.modal.regenerate_message')}</Text>
            </Box>
          }
        ></CustomModalLayout>
      </Modal>
    );
  }

  displayModalRegenerateReturn = () => {
    return (
      <Modal
        isOpen={this.state.modalRegenerateReturn}
        onRequestClose={() => this.reinitVars()}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
          primaryButtonText={I18n.t('order_list.modal.regenerate_ok_button')}
          secondaryButtonText={I18n.t('order_list.modal.cancel_button')}
          onCloseButtonClick={() => this.reinitVars()}
          secondaryButtonOnClick={() => this.reinitVars()}
          primaryButtonOnClick={() => this.generateLabelReturn(this.state.regenerate_current_order_id, false, this.state.regenerate_current_label_id, true)}
          title={I18n.t('order_list.modal.regenerate_title')}
          content={
            <Box direction="vertical" marginBottom="SP2">
              <Text>{I18n.t('order_list.modal.regenerate_message')}</Text>
            </Box>
          }
      ></CustomModalLayout>
      </Modal>
    );
  }

  displayModalBulkGenerate = () => {
    return (
      <Modal
        isOpen={this.state.modalBulkGenerate}
        onRequestClose={() => this.setState({modalBulkGenerate: false})}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
          primaryButtonText={I18n.t('order_list.modal.generate_ok_button')}
          secondaryButtonText={I18n.t('order_list.modal.cancel_button')}
          onCloseButtonClick={() => this.setState({modalBulkGenerate: false})}
          secondaryButtonOnClick={() => this.setState({modalBulkGenerate: false})}
          primaryButtonOnClick={() => this.generateBulkLabel()}
          title={I18n.t('order_list.modal.generate_bulk_label_title')}
          content={
            <Box direction="vertical" marginBottom="SP2">
              <Text>{I18n.t('order_list.modal.generate_bulk_label_message')}</Text>
            </Box>
          }
        ></CustomModalLayout>
      </Modal>
    );
  }

  displayModalAddress = (shipping) => {
    return (
      <Modal
        isOpen={this.state.modalChangeAddress}
        onRequestClose={() => this.setState({modalChangeAddress: false})}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
            onCloseButtonClick={() => this.setState({modalChangeAddress: false})}
            title={I18n.t('order_list.modal.modify_address')}
            content={
              <Box direction="vertical" marginBottom="SP2">
                <Layout>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('order_list._form.firstname')}
                      required
                    >
                      <Input
                        type="text"
                        status={shipping.first_name !== null && shipping.first_name.length > 0 ? '' : 'error'}
                        name="first_name"
                        statusMessage={shipping.first_name !== null && shipping.first_name.length > 0 ? '' : I18n.t('configs.address.firstname_error')}
                        tooltipPlacement="top-end"
                        value={shipping.first_name}
                        onChange={this.handleChangeAddress}
                        maxLength="35"
                        suffix={<Input.Affix>{shipping.first_name !== null ? 35 - shipping.first_name.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('order_list._form.lastname')}
                      required
                    >
                      <Input
                        type="text"
                        status={shipping.last_name !== null && shipping.last_name.length > 0 ? '' : 'error'}
                        name="last_name"
                        statusMessage={shipping.last_name !== null && shipping.last_name.length > 0 ? '' : I18n.t('configs.address.lastname_error')}
                        tooltipPlacement="top-end"
                        value={shipping.last_name}
                        onChange={this.handleChangeAddress}
                        suffix={<Input.Affix>{shipping.last_name !== null ? 35 - shipping.last_name.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                </Layout>
                <Layout>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('order_list._form.company_name')}
                    >
                      <Input
                        type="text"
                        name="company"
                        tooltipPlacement="top-end"
                        value={shipping.company}
                        onChange={this.handleChangeAddress}
                        maxLength="35"
                        suffix={<Input.Affix>{shipping.company !== null ? 35 - shipping.company.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('order_list._form.mobile_phone')}
                      required
                    >
                      <Input
                        type="text"
                        status={shipping.phone !== null && shipping.phone.length > 0 ? '' : 'error'}
                        name="phone"
                        statusMessage={shipping.phone !== null && shipping.phone.length > 0 ? '' : I18n.t('configs.address.phone_error')}
                        tooltipPlacement="top-end"
                        value={shipping.phone}
                        onChange={this.handleChangeAddress}
                      />
                      <Text size="tiny">{I18n.t('configs.address.phone_help')}</Text>
                    </FormField>
                  </Cell>
                </Layout>
                <Cell>
                  <FormField
                    label={I18n.t('order_list._form.address1')}
                    required
                  >
                    <Input
                      type="text"
                      status={shipping.address1 !== null && shipping.address1.length > 0 ? '' : 'error'}
                      name="address1"
                      statusMessage={shipping.address1 !== null && shipping.address1.length > 0 ? '' : I18n.t('configs.address.address1_error')}
                      tooltipPlacement="top-end"
                      value={shipping.address1}
                      onChange={this.handleChangeAddress}
                      maxLength="35"
                      suffix={<Input.Affix>{shipping.address1 !== null ? 35 - shipping.address1.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Cell>
                  <FormField
                    label={I18n.t('order_list._form.address2')}
                  >
                    <Input
                      type="text"
                      name="address2"
                      tooltipPlacement="top-end"
                      value={shipping.address2}
                      onChange={this.handleChangeAddress}
                      maxLength="35"
                      suffix={<Input.Affix>{shipping.address2 !== null ? 35 - shipping.address2.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                  <br/>
                </Cell>
                <Layout>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('order_list._form.zip_code')}
                      required
                    >
                      <Input
                        status={shipping.zip !== null && shipping.zip.length > 0 ? '' : 'error'}
                        name="zip"
                        statusMessage={shipping.zip !== null && shipping.zip.length > 0 ? '' : I18n.t('configs.address.postcode_error')}
                        tooltipPlacement="top-end"
                        value={shipping.zip}
                        onChange={this.handleChangeAddress}
                      />
                    </FormField>
                  </Cell>
                  <Cell span={6}>
                    <FormField
                      label={I18n.t('order_list._form.city')}
                      required
                    >
                      <Input
                        type="text"
                        status={shipping.city !== null && shipping.city.length > 0 ? '' : 'error'}
                        name="city"
                        statusMessage={shipping.city !== null && shipping.city.length > 0 ? '' : I18n.t('configs.address.city_error')}
                        tooltipPlacement="top-end"
                        value={shipping.city}
                        onChange={this.handleChangeAddress}
                        maxLength="35"
                        suffix={<Input.Affix>{shipping.city !== null ? 35 - shipping.city.length +`/35` : `35/35`}</Input.Affix>}
                      />
                    </FormField>
                  </Cell>
                </Layout>
                <br/><br/>
                <Cell>
                  <Page.Footer divider>
                    <Page.Footer.End>
                      <Button onClick={(e) => this.handleSubmit(e)}>{I18n.t('order_list._form.save_address')}</Button>
                    </Page.Footer.End>
                  </Page.Footer>
                </Cell>
              </Box>
            }
        ></CustomModalLayout>
      </Modal>
    );
  }

  displayModalAddressPickup = (shipping) => {
    return (
      <Modal
        isOpen={this.state.modalChangeAddressPickup}
        onRequestClose={() => this.setState({modalChangeAddressPickup: false})}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
          onCloseButtonClick={() => this.setState({modalChangeAddressPickup: false})}
          title={I18n.t('order_list.modal.modify_address')}
          content={
            <Box direction="vertical" marginBottom="SP2">
              <Layout>
                <Cell span={6}>
                  <FormField
                    label={I18n.t('order_list._form.company_name')}
                  >
                    <Input
                      type="text"
                      name="company"
                      tooltipPlacement="top-end"
                      value={shipping.company_name}
                      onChange={this.handleChangeAddressPickup}
                      maxLength="35"
                      suffix={<Input.Affix>{shipping.company_name !== null ? 35 - shipping.company_name.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                </Cell>
                <Cell span={6}>
                  <FormField
                    label={I18n.t('order_list._form.mobile_phone')}
                    required
                  >
                    <Input
                      type="text"
                      status={shipping.phone !== null && shipping.phone.length > 0 ? '' : 'error'}
                      name="phone"
                      statusMessage={shipping.phone !== null && shipping.phone.length > 0 ? '' : I18n.t('configs.address.phone_error')}
                      tooltipPlacement="top-end"
                      value={shipping.phone}
                      onChange={this.handleChangeAddressPickup}
                    />
                    <Text size="tiny">{I18n.t('configs.address.phone_help')}</Text>
                  </FormField>
                </Cell>
              </Layout>
              <Cell>
                <FormField
                  label={I18n.t('order_list._form.address1')}
                  required
                >
                  <Input
                    type="text"
                    status={shipping.address1 !== null && shipping.address1.length > 0 ? '' : 'error'}
                    name="address1"
                    statusMessage={shipping.address1 !== null && shipping.address1.length > 0 ? '' : I18n.t('configs.address.address1_error')}
                    tooltipPlacement="top-end"
                    value={shipping.address1}
                    onChange={this.handleChangeAddressPickup}
                    maxLength="35"
                    suffix={<Input.Affix>{shipping.address1 !== null ? 35 - shipping.address1.length +`/35` : `35/35`}</Input.Affix>}
                  />
                </FormField>
                <br/>
              </Cell>
              <Cell>
                <FormField
                  label={I18n.t('order_list._form.address2')}
                >
                  <Input
                    type="text"
                    name="address2"
                    tooltipPlacement="top-end"
                    value={shipping.address2}
                    onChange={this.handleChangeAddressPickup}
                    maxLength="35"
                    suffix={<Input.Affix>{shipping.address2 !== null ? 35 - shipping.address2.length +`/35` : `35/35`}</Input.Affix>}
                  />
                </FormField>
                <br/>
              </Cell>
              <Layout>
                <Cell span={6}>
                  <FormField
                    label={I18n.t('order_list._form.zip_code')}
                    required
                  >
                    <Input
                      type="number"
                      status={shipping.zipcode !== null && shipping.zipcode.length > 0 ? '' : 'error'}
                      name="zipcode"
                      statusMessage={shipping.zipcode !== null && shipping.zipcode.length > 0 ? '' : I18n.t('configs.address.postcode_error')}
                      tooltipPlacement="top-end"
                      value={shipping.zipcode}
                      onChange={this.handleChangeAddressPickup}
                    />
                  </FormField>
                </Cell>
                <Cell span={6}>
                  <FormField
                    label={I18n.t('order_list._form.city')}
                    required
                  >
                    <Input
                      type="text"
                      status={shipping.city !== null && shipping.city.length > 0 ? '' : 'error'}
                      name="city"
                      statusMessage={shipping.city !== null && shipping.city.length > 0 ? '' : I18n.t('configs.address.city_error')}
                      tooltipPlacement="top-end"
                      value={shipping.city}
                      onChange={this.handleChangeAddressPickup}
                      maxLength="35"
                      suffix={<Input.Affix>{shipping.city !== null ? 35 - shipping.city.length +`/35` : `35/35`}</Input.Affix>}
                    />
                  </FormField>
                </Cell>
              </Layout>
              <br/><br/>
              <Cell>
                <Page.Footer divider>
                  <Page.Footer.End>
                    <Button onClick={(e) => this.handleSubmitPickup(e)}>{I18n.t('order_list._form.save_address')}</Button>
                  </Page.Footer.End>
                </Page.Footer>
              </Cell>
            </Box>
          }
        ></CustomModalLayout>
      </Modal>
    );
  }

  deleteBulkOrderConfirm = () => {
    return (
      <Modal
        isOpen={this.state.modalOpenOrderlistBuklDelete}
        onRequestClose={() => this.setState({modalOpenOrderlistBuklDelete: false})}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
          primaryButtonText={I18n.t('order_list.modal.delete_ok_button')}
          secondaryButtonText={I18n.t('order_list.modal.cancel_button')}
          onCloseButtonClick={() => this.setState({modalOpenOrderlistBuklDelete: false})}
          secondaryButtonOnClick={() => this.setState({modalOpenOrderlistBuklDelete: false})}
          primaryButtonOnClick={() => this.deleteBulkOrder()}
          title={I18n.t('order_list.modal.delete_bulk_order_title')}
          content={
            <Box direction="vertical" marginBottom="SP2">
              <Text>{I18n.t('order_list.modal.delete_bulk_order_message')}</Text>
            </Box>
          }
        ></CustomModalLayout>
      </Modal>
    );
  }

  displayModalImport = () => {
    return (
      <Modal
        isOpen={this.state.modalImport}
        onRequestClose={() => this.setState({modalImport: false})}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
          primaryButtonText={I18n.t('order_list.modal.import_orders')}
          secondaryButtonText={I18n.t('order_list.modal.cancel_button')}
          onCloseButtonClick={() => this.setState({modalImport: false})}
          secondaryButtonOnClick={() => this.setState({modalImport: false})}
          primaryButtonOnClick={() => this.handleImportOrders()}
          title={I18n.t('order_list.modal.import_title')}
          content={
            <Box direction="vertical" marginBottom="SP2">
              <Text>{I18n.t('order_list.modal.import_message')}</Text>
              <br/>
              <FormField
                label={I18n.t('order_list.modal.import_order_form')}
                required
              >
                <Input
                  type="text"
                  status={this.state.import_orders !== null && this.state.import_orders.length > 0 ? '' : 'error'}
                  name="import_orders"
                  statusMessage={this.state.import_orders !== null && this.state.import_orders.length > 0 ? '' : I18n.t('order_list.modal.import_order_error')}
                  tooltipPlacement="top-end"
                  value={this.state.import_orders}
                  onChange={this.handleChangeImportOrders}
                />
              </FormField>
            </Box>
          }
        ></CustomModalLayout>
      </Modal>
    );
  }

  disambiguateLabel = (key, value) => {
    const options = {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false,
        timeZone: this.props.shop.time_zone
    };

    switch (key) {
      case 'weight':
        return `${I18n.t('order_list.filters.weight_label')} ${value[0]} ${I18n.t('order_list.filters.grams')} ${I18n.t('order_list.filters.operator')} ${value[1]} ${I18n.t('order_list.filters.grams')}`;
      case 'fulfillmentStatus':
        return value.map((val) => `${I18n.t(val)}`).join(', ');
      case 'paymentStatus':
        return value.map((val) => `${I18n.t(val)}`).join(', ');
      case 'labelStatus':
        switch (value[0]) {
          case 'unavailable':
            return `${I18n.t('order_list.filters.unavailable_label')}`;
          case 'available':
            return `${I18n.t('order_list.filters.available_label')}`;
          case 'return':
            return `${I18n.t('order_list.filters.return_label')}`;
          default:
            return null;
        }
      case 'printedStatus':
        switch (value[0]) {
          case true:
            return `${I18n.t('order_list.filters.printed')}`;
          case false:
            return `${I18n.t('order_list.filters.unprint')}`;
          default:
            return null;
        }
      case 'closedStatus':
        switch (value[0]) {
          case true:
            return `${I18n.t('order_list.filters.archived_order')}`;
          case false:
            return `${I18n.t('order_list.filters.unarchived_order')}`;
          default:
            return null;
        }
      case 'errorStatus':
        switch (value[0]) {
          case 'error':
            return `${I18n.t('order_list.filters.error_generating_label')}`;
          default:
            return null;
        }
      case 'date':
        switch (value[0]) {
          case 'past_day':
            return `${I18n.t('order_list.filters.date_today')}`;
          case 'past_week':
            return `${I18n.t('order_list.filters.date_past_week')}`;
          case 'past_month':
            return `${I18n.t('order_list.filters.date_past_month')}`;
          case 'past_quarter':
            return `${I18n.t('order_list.filters.date_past_quarter')}`;
          case 'past_year':
            return `${I18n.t('order_list.filters.date_past_year')}`;
          default:
            return null;
        }
      case 'date_from':
        return `${I18n.t('order_list.filters.date_from')} ${new Intl.DateTimeFormat('default', options).format(new Date(value))}`;
      case 'date_to':
        return `${I18n.t('order_list.filters.date_to')} ${new Intl.DateTimeFormat('default', options).format(new Date(value))}`;
      case 'countries':
        return value.map((val) => `${val}`).join(', ');
      case 'services':
        return value.map((val) => `${val}`).join(', ');
      default:
        return value;
    }
};

  render() {
    const {
      orders,
      loading,
      modalChangeAddress,
      modalChangeAddressPickup,
      modalOpenOrderlistBuklDelete,
      modalRegenerate,
      modalRegenerateReturn,
      modalBulkGenerate,
      modalImport,
      orderShipping,
      orderShippingPickup,
      filterSide,
      queryValue
    } = this.state;

    const columns = [
      {
        title: I18n.t('order_list.order_number'),
        render: (row) => this.renderColumnOrderNumber(row),
        width: 260
      },
      {
        title: I18n.t('order_list.customer'),
        render: (row) => this.renderColumnCustomer(row),
        width: 150
      },
      {
        title: I18n.t('order_list.fulfillmment'),
        render: (row) => this.renderColumnFulfillment(row),
        width: 120,
        align: 'center'
      },
      {
        title: I18n.t('order_list.weight'),
        render: (row) => this.renderColumnWeight(row),
        width: 80
      },
      {
        title: I18n.t('order_list.options'),
        render: (row) => this.renderColumnOptions(row),
        width: 260
      },
      {
        title: I18n.t('order_list.actions'),
        render: (row) => this.renderColumnActions(row),
        width: 120
      }
    ];

    const includeFilters = [
      'queryValue',
      'paymentStatus',
      'printedStatus',
      'fulfillmentStatus',
      'labelStatus',
      'closedStatus',
      'errorStatus',
      'weight',
      'date',
      'date_from',
      'date_to',
      'countries',
      'services'
    ];

    const appliedFilters = Object.keys(this.state)
      .filter((key) => !isEmpty(this.state[key]) && includeFilters.indexOf(key) !== -1)
      .map((key) => {
        return {
        id: key,
        value: this.state[key],
        type: key,
        children: this.disambiguateLabel(key, this.state[key]),
        };
    });

    const tagExists = ({ type, value }) =>
      this.state[type].some((tag) => tag === value)

    const LabelFilter = [
      {
        label: I18n.t('order_list.filters.unavailable_label'),
        value: 'unavailable',
      },
      {
        label: I18n.t('order_list.filters.available_label'),
        value: 'available',
      },
      {
        label: I18n.t('order_list.filters.return_label'),
        value: 'return',
      },
    ];

    const PrintedFilter = [
      {
        label: I18n.t('order_list.filters.printed'),
        value: true,
      },
      {
        label: I18n.t('order_list.filters.unprint'),
        value: false,
      },
    ];

    const dateFilter = [
      {label: I18n.t('order_list.filters.date_today'), value: 'past_day'},
      {label: I18n.t('order_list.filters.date_past_week'), value: 'past_week'},
      {label: I18n.t('order_list.filters.date_past_month'), value: 'past_month'},
      {label: I18n.t('order_list.filters.date_past_quarter'), value: 'past_quarter'},
      {label: I18n.t('order_list.filters.date_past_year'), value: 'past_year'},
      {label: I18n.t('order_list.filters.date_custom'), value: 'custom'},
    ];

    const paginationMarkup =
      this.state.total_page > 1 ? (
      <Pagination
        currentPage={this.state.page}
        totalPages={this.state.total_page}
        onChange={(e) => this.handleChangePage(e.page)}
      />
  ) : null;

    const emptyStateMarkup = (!orders.length && loading === false) ? (
      <Card className="notroundedTop">
      <Table.EmptyState
        subtitle={<Box direction="vertical" paddingTop="SP2">
          <Box><br/></Box>
          <Box align="center"><Text weight="bold">{I18n.t('emptystate.orders.title')}</Text></Box>
          <Box align="center">{I18n.t('emptystate.orders.text1')}</Box>
          <Box align="center"><TextButton as="a" href="https://www.loom.com/share/b04d8d31553d402cb18d7d2bd54aec73?sid=54e33208-d1e7-40e3-b0f4-26a5a9ecf5ed" target="_blank">{I18n.t('emptystate.orders.url_link1')}</TextButton></Box>
          <Box align="center">{I18n.t('emptystate.orders.text2')}</Box>
          <Box align="center"><TextButton as="a" href="https://www.loom.com/share/a63194882594435ab0fe56125c41e1df?sid=3bb66af3-4e5a-4c3c-88e3-a64cb0d3b3de" target="_blank">{I18n.t('emptystate.orders.url_link2')}</TextButton></Box>
        </Box>}
        image={
          <Image
            height={226}
            width={226}
            src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a9a34fdb674e2d572b7177_no-Commandes_226.svg"
            transparent
          />
        }
      >
        <Button as="a" href="https://loom.com/share/folder/c13b118bcbe94b7f8dde5926bacfae92" target="_blank">{I18n.t('emptystate.link_text')}</Button>
      </Table.EmptyState></Card>
    ) : undefined;

    return (
      <div>
        <Page width="100%" className="fullWidth" height="100vh">
          <Page.Header
            title={I18n.t('order_list.resources_items_orders_title')}
            subtitle={<Image src={LogoColissimo} width="60" transparent />}
            actionsBar={<Box>
              {this.state.remaining_days !== false &&
                <Button as="a" skin="premium" href={this.props.upgrade_url} target="_blank">{I18n.t('upgrade.upgrade_app_button')}&nbsp;-&nbsp;{this.state.remaining_days}&nbsp;{I18n.t('upgrade.remaining_days')} </Button>
              }&nbsp;
              <Button skin="inverted" prefixIcon={<DownloadImportSmall />} onClick={(e) => { this.setState({modalImport: true}); }} >
                {I18n.t('order_list.import_orders')}
              </Button>
              &nbsp;&nbsp;
              <Button onClick={(e) => { this.setState({loading: true}, () => {
              this.callRequest('/orders-filters?page='+this.state.page+'&limit='+this.state.page_limit);
            });}}>{I18n.t('order_list.refresh')}</Button></Box>}
          ></Page.Header>
          <Page.Content>
            <Modal
              screen="desktop"
              isOpen={loading}
            >
              <Loader size="large" />
            </Modal>
            <Table
              data={orders}
              columns={columns}
              horizontalScroll
              stickyColumns={2}
              showSelection
              onSelectionChanged={this.handleSelectionChange}
              selectedIds={this.state.selectedItems}
            >
              <Page.Sticky>
                <Card className="notroundedBottom">
                  <Tabs
                    items={[
                      { id: 0, title: <Text size="small">{I18n.t('order_list._tabs.all')}</Text> },
                      { id: 1, title: <Text size="small">{I18n.t('order_list._tabs.without_label')}</Text> },
                      { id: 2, title: <Text size="small">{I18n.t('order_list._tabs.with_label')}</Text> },
                      { id: 3, title: <Text size="small">{I18n.t('order_list._tabs.unfulfilled')}</Text> },
                      { id: 4, title: <Text size="small">{I18n.t('order_list._tabs.error')}</Text> },
                    ]}
                    activeId={this.state.selectedTabConfig}
                    type="uniformSide"
                    onClick={(value) => this.handleTabChange(value)}
                  />
                </Card>
                <Card className="notrounded">
                  <TableToolbar>
                    {this.state.selectedItems.length > 0 &&
                      <TableToolbar.ItemGroup position="start">
                        <TableToolbar.Item>
                          <Box gap="12px">
                            <Box gap="3px">
                              <Text size="small" weight="bold">
                                {this.state.selectedItems.length} {I18n.t('order_list.resources_items_orders_title')} {I18n.t('order_list.selected')}
                              </Text>
                              <Text size="small">{I18n.t('order_list.on_total')} {this.state.orders.length}</Text>
                            </Box>
                          </Box>
                        </TableToolbar.Item>
                        <TableToolbar.Item>
                          <Box height="18px">
                            <Divider direction="vertical" />
                          </Box>
                        </TableToolbar.Item>
                        <TableToolbar.Item layout="button">
                          <Button
                            skin="inverted"
                            size="small"
                            onClick={(e) => this.generateBulkLabelCheckModal()}
                            prefixIcon={<ShippingSmall />}
                          >
                            {I18n.t('order_list.bulk_generate_label')}
                          </Button>
                        </TableToolbar.Item>
                        <TableToolbar.Item layout="button">
                          <PopoverMenu
                            triggerElement={
                              <Button
                                skin="inverted"
                                size="small"
                                suffixIcon={<ChevronDownSmall />}
                              >
                                {I18n.t('order_list.more_actions')}
                              </Button>
                            }
                          >
                            <PopoverMenu.MenuItem
                              prefixIcon={<PrintSmall />}
                              text={I18n.t('order_list.bulk_print_label')}
                              onClick={(e) => this.printBulkLabel()}
                            />
                            <PopoverMenu.MenuItem
                              prefixIcon={<PrintSmall />}
                              text={I18n.t('order_list.bulk_print_return_label')}
                              onClick={(e) => this.printBulkReturnLabel()}
                            />
                            <PopoverMenu.MenuItem
                              prefixIcon={<DeleteSmall />}
                              text={I18n.t('order_list.bulk_delete_order')}
                              skin="destructive"
                              onClick={(e) => this.dialogConfirmDelete()}
                            />
                          </PopoverMenu>
                        </TableToolbar.Item>
                      </TableToolbar.ItemGroup>
                    }
                    {this.state.selectedItems.length <= 0 &&
                      <TableToolbar.ItemGroup position="start">
                        <TableToolbar.Item>
                          <TableToolbar.Label>{this.state.orders.length}{I18n.t('order_list.resources_items_orders_title')}</TableToolbar.Label>
                        </TableToolbar.Item>
                      </TableToolbar.ItemGroup>
                    }
                    <TableToolbar.ItemGroup position="end">
                      <TableToolbar.Item>
                        <Button
                          size="small"
                          priority="secondary"
                          prefixIcon={<ContentFilterSmall />}
                          onClick={(e) => this.toggleActive("filterSide")}
                        >
                          {I18n.t('order_list.filters.filters')} (9)
                        </Button>
                      </TableToolbar.Item>
                      <TableToolbar.Item>
                        <Search name="queryValue" size="small" value={queryValue} onChange={this.handleChangeQueryValue} onClear={this.handleClearQueryValue}/>
                      </TableToolbar.Item>
                    </TableToolbar.ItemGroup>
                  </TableToolbar>
                  <Table.Titlebar />
                  <Table.SubToolbar>
                    <Box verticalAlign="middle" width="100%" align="space-between">
                      <Box gap="12px" verticalAlign="middle">
                        <Text size="small">{I18n.t('order_list.filters.filter_by')}</Text>
                        <TagList
                          tags={appliedFilters}
                          actionButton={{
                            label: I18n.t('order_list.filters.clear_all'),
                            onClick: () => this.handleClearAll(),
                          }}
                          onTagRemove={(e) => this.handleRemove(e)}
                        />
                      </Box>
                    </Box>
                  </Table.SubToolbar>
                </Card>
              </Page.Sticky>
              <Table.Content titleBarVisible={false}/>
              {emptyStateMarkup}
            </Table>
            <br/>
            <Layout justifyItems="center">
              <Cell>
                {paginationMarkup}
              </Cell>
            </Layout>
            <Box>
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  right: `${filterSide ? 0 : -440}px`,
                  display: `${filterSide ? 'block' : 'none'}`,
                  height: '100%',
                  boxShadow:
                    '0 3px 24px 0 rgba(22, 45, 61, 0.18), 0 8px 8px 0 rgba(22, 45, 61, 0.12)',
                  transition: 'right 0.4s ease 0s',
                  zIndex: 2000,
                }}
              >
                <SidePanel title="Filter" onCloseButtonClick={() => this.handleCloseSheet()}>
                  <SidePanel.Header title={I18n.t('order_list.filters.filters')} />
                  <SidePanel.Content className="Nopadding">
                  <Accordion
                    skin="light"
                    hideShadow
                    size="small"
                    items={[
                      {
                        title: I18n.t('order_list.filters.payment_status'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            {this.props.payment_status.map((value, key) => (
                              <Checkbox
                                checked={tagExists({
                                  type: 'paymentStatus',
                                  value: value,
                                })}
                                onChange={(e) => this.toggleTag('paymentStatus', value)}
                              >
                                {I18n.t(value)}
                              </Checkbox>
                            ))}
                            <TextButton size="small" onClick={(e) => this.handleClear('paymentStatus')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.fulfill_status'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            {this.props.fulfillment_status.map((value, key) => (
                              <Checkbox
                                checked={tagExists({
                                  type: 'fulfillmentStatus',
                                  value: value,
                                })}
                                onChange={(e) => this.toggleTag('fulfillmentStatus', value)}
                              >
                                {I18n.t(value)}
                              </Checkbox>
                            ))}
                            <TextButton size="small" onClick={(e) => this.handleClear('fulfillmentStatus')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.labelStatus'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            {LabelFilter.map((value, key) => (
                              <Radio
                                checked={tagExists({
                                  type: 'labelStatus',
                                  value: value.value,
                                })}
                                onChange={(e) => this.toggleTag('labelStatus', value.value)}
                                label={value.label}
                              />
                            ))}
                            <TextButton size="small" onClick={(e) => this.handleClear('labelStatus')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.printedStatus'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            {PrintedFilter.map((value, key) => (
                              <Radio
                                checked={tagExists({
                                  type: 'printedStatus',
                                  value: value.value,
                                })}
                                onChange={(e) => this.toggleTag('printedStatus', value.value)}
                                label={value.label}
                              />
                            ))}
                            <TextButton size="small" onClick={(e) => this.handleClear('printedStatus')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.errorStatus'),
                        children: (
                          <Box direction="vertical" gap="12px">
                              <Radio
                                checked={tagExists({
                                  type: 'errorStatus',
                                  value: 'error',
                                })}
                                onChange={(e) => this.toggleTag('errorStatus', 'error')}
                                label={I18n.t('order_list.filters.errorStatus')}
                              />
                              <TextButton size="small" onClick={(e) => this.handleClear('errorStatus')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.countries'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            {this.props.countries.map((value, key) => (
                              <Checkbox
                                checked={tagExists({
                                  type: 'countries',
                                  value: value,
                                })}
                                onChange={(e) => this.toggleTag('countries', value)}
                              >
                                {this.capitalize(value)}
                              </Checkbox>
                            ))}
                            <TextButton size="small" onClick={(e) => this.handleClear('countries')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.services'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            {this.props.services.map((value, key) => (
                              <Checkbox
                                checked={tagExists({
                                  type: 'services',
                                  value: value,
                                })}
                                onChange={(e) => this.toggleTag('services', value)}
                              >
                                {value}
                              </Checkbox>
                            ))}
                            <TextButton size="small" onClick={(e) => this.handleClear('services')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.weight'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            <Slider
                              marks={{
                                0: `0 Kg`,
                                5: `5 Kg`,
                                10: `10 Kg`,
                                30: `30 Kg`,
                                50: `50 Kg`,
                              }}
                              min={0}
                              max={50}
                              value={this.state.weight || [0, 50]}
                              onChange={(e) => { this.toggleTag('weight', e)}}
                            />
                            <TextButton size="small" onClick={(e) => this.handleClear('weight')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                      {
                        title: I18n.t('order_list.filters.date'),
                        children: (
                          <Box direction="vertical" gap="12px">
                            {dateFilter.map((value, key) => (
                              <Radio
                                checked={tagExists({
                                  type: 'date',
                                  value: value.value,
                                })}
                                onChange={(e) => this.toggleTag('date', value.value)}
                                label={value.label}
                              />
                            ))}
                            {this.state.date[0] == 'custom' &&
                              <Box direction="vertical">
                                <FormField label={I18n.t('order_list.filters.date_from')}>
                                  <DatePicker placeholderText="Date" size="medium" width="240px" value={this.state.date_from} onChange={this.handleChange('date_from')} />
                                </FormField>
                                <FormField label={I18n.t('order_list.filters.date_to')}>
                                  <DatePicker placeholderText="Date" size="medium" width="240px" value={this.state.date_to} onChange={this.handleChange('date_to')} />
                                </FormField>
                              </Box>
                            }
                            <TextButton size="small" onClick={(e) => this.handleClear('date')}>{I18n.t('order_list.filters.clear')}</TextButton>
                          </Box>
                        ),
                      },
                    ]}
                  />
                  </SidePanel.Content>
                  <SidePanel.Footer>
                    <Box gap="12px" paddingBottom="SP4">
                      <Text size="small">{appliedFilters.length} {I18n.t('order_list.filters.filters_applied')}</Text>
                      <TextButton size="small" onClick={(e) => this.handleClearAll()}>{I18n.t('order_list.filters.clear_all')}</TextButton>
                    </Box>
                    <Button priority="secondary" onClick={(e) => this.handleCloseSheet()} fullWidth>
                      {I18n.t('order_list.filters.close')}
                    </Button>
                  </SidePanel.Footer>
                </SidePanel>
              </div>
            </Box>
          </Page.Content>
        </Page>
        {!this.state.selectedOrder === false ? this.renderSheet(this.state.selectedOrder) : null}
        {!this.state.selectedLabels === false ? this.renderSheetLabels(this.state.selectedLabels) : null}
        {!this.state.selectedChange === false ? this.renderSheetChange(this.state.selectedChange) : null}
        {!this.state.selectedChangeOffer === false ? this.renderSheetChangeOffer(this.state.selectedChangeOffer) : null}
        <Modal
        isOpen={this.state.map_modal}
        onRequestClose={() => this.setState({map_modal: false})}
        shouldCloseOnOverlayClick
        screen="desktop"
        >
          <CustomModalLayout
            onCloseButtonClick={() => this.setState({map_modal: false})}
            title={I18n.t('front.modal_header')}
            content={
              <Box direction="vertical">
                <div style={{display: 'none'}}>
                  <input name="colissimo_order_service_update" id="order-update-webservice" value="" onClick={(e) => this.handleChange("colissimo_order_service_update")} type="hidden" ref={(orderUpdateWebservice) => { this.orderUpdateWebservice = orderUpdateWebservice }} />
                  <Button size="slim" primary={false} id="validPickup" onClick={(e) => this.handleValidPickup()}></Button>
                </div>
                <div id="colissimo-widget-container" class="wix-admin">
                  <Box direction="vertical" align="center" padding="SP4">
                    <Loader size="medium" />
                    <Text skin="standard">{I18n.t('front.please_wait')}</Text>
                    </Box>
                </div>
              </Box>
            }
          />
        </Modal>
        {modalChangeAddress ? this.displayModalAddress(orderShipping) : null}
        {modalChangeAddressPickup ? this.displayModalAddressPickup(orderShippingPickup) : null}
        {modalRegenerate ? this.displayModalRegenerate() : null}
        {modalRegenerateReturn ? this.displayModalRegenerateReturn() : null}
        {modalBulkGenerate ? this.displayModalBulkGenerate() : null}
        {modalImport ? this.displayModalImport() : null}
        {modalOpenOrderlistBuklDelete ? this.deleteBulkOrderConfirm() : null}
      </div>
    );
  }
}

function isEmpty(value) {
  if (Array.isArray(value)) {
      if (value[0] == "custom") {
          return true;
      }
      return value.length === 0;
  } else {
      /* Add specific Hack for custom value */
      return value === '' || value == null;
  }
}

export default OrderIndex
